
function syncAutocompleteWidth() {
    const wrapper = document.querySelector('.wizzy-autocomplete-wrapper');
    if (!wrapper) return;

    var viewportPadLeft = 12;
    var viewportPadRight = 12;
    var available = Math.max(0, window.innerWidth - viewportPadLeft - viewportPadRight);
    var isMobile = window.innerWidth <= 768;
    var gapBelowSearch = 8;

    // Anchor panel below the header search so it never overlaps the input.
    var searchEl =
        document.querySelector('.aone-header__search:focus-within') ||
        (document.activeElement &&
            document.activeElement.closest &&
            document.activeElement.closest('.aone-header__search')) ||
        document.querySelector('.aone-header__search');
    if (searchEl) {
        var searchBottom = searchEl.getBoundingClientRect().bottom;
        wrapper.style.top = Math.round(searchBottom + gapBelowSearch) + 'px';
    }

    var top = wrapper.getBoundingClientRect().top;
    var spaceBelow = Math.max(220, window.innerHeight - top - 16);
    // Desktop: allow more height (~72vh); mobile: use remaining space
    var maxH = isMobile ? spaceBelow : Math.min(spaceBelow, Math.floor(window.innerHeight * 0.72));
    wrapper.style.maxHeight = maxH + 'px';
    wrapper.style.overflowY = 'auto';
    wrapper.style.overflowX = 'auto';
    wrapper.style.webkitOverflowScrolling = 'touch';
    wrapper.style.boxSizing = 'border-box';

    if (isMobile) {
        wrapper.style.left = viewportPadLeft + 'px';
        wrapper.style.right = viewportPadRight + 'px';
        wrapper.style.width = available + 'px';
        wrapper.style.minWidth = '0';
        wrapper.style.maxWidth = available + 'px';
        wrapper.style.overflowX = 'hidden';
        return;
    }

    // Desktop: size to content, cap at viewport; scroll if content > vw
    wrapper.style.right = 'auto';
    wrapper.style.width = 'max-content';
    wrapper.style.minWidth = Math.min(920, available) + 'px';
    wrapper.style.maxWidth = available + 'px';

    var left = parseFloat(wrapper.style.left);
    if (isNaN(left)) {
        left = wrapper.getBoundingClientRect().left;
    }

    // Measure natural content width after max-content applies
    var contentW = Math.ceil(wrapper.scrollWidth);
    var panelW = Math.min(Math.max(contentW, Math.min(920, available)), available);

    if (left + panelW > window.innerWidth - viewportPadRight) {
        left = Math.max(viewportPadLeft, window.innerWidth - viewportPadRight - panelW);
    }
    if (left < viewportPadLeft) left = viewportPadLeft;
    wrapper.style.left = left + 'px';
}

/**
 * Default to in-stock-only so pagination / totals match visible cards.
 * Do not override when the shopper explicitly picks In Stock / Out of Stock.
 *
 * Note: forcing inStock on filter requests makes Wizzy rebuild
 * `.search-filters-top-wrapper`. Grid / Order sheet is mounted in the
 * collection breadcrumb nav on mobile, and in the top bar on desktop / SLP.
 * @param {object|string|null|undefined} filters
 * @returns {object|string|null|undefined}
 */
function forceWizzyInStockOnlyOnFilters(filters) {
    return ;
    if (filters == null) return filters;

    var asString = typeof filters === 'string';
    var parsed = filters;

    if (asString) {
        try {
            parsed = JSON.parse(filters);
        } catch (e) {
            return filters;
        }
    }

    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return filters;
    }

    if (parsed.inStock != null && (Array.isArray(parsed.inStock) ? parsed.inStock.length > 0 : String(parsed.inStock).length > 0)) {
        var values = Array.isArray(parsed.inStock) ? parsed.inStock : [parsed.inStock];
        var wantsOos = values.some(function (v) {
            return String(v).toLowerCase() === 'false';
        });
        var wantsIn = values.some(function (v) {
            return String(v).toLowerCase() === 'true';
        });
        if (wantsOos && !wantsIn) {
            parsed.includeOutOfStock = 'true';
        } else if (wantsIn && !wantsOos) {
            parsed.includeOutOfStock = 'false';
        }
        return asString ? JSON.stringify(parsed) : parsed;
    }

    /* Keep API in-stock default for pagination/totals. Switcher is mounted outside
     * the rebuilt top-bar so the facet chrome no longer blocks Order sheet. */
    parsed.inStock = ['true'];
    parsed.includeOutOfStock = 'false';

    return asString ? JSON.stringify(parsed) : parsed;
}

/**
 * Apply default in-stock-only constraint on search / filter request payloads.
 * Respects an explicit inStock facet choice (including Out of Stock).
 * @param {object} data
 * @returns {object}
 */
function forceWizzyInStockOnlyRequest(data) {
    return ;
    if (!data || typeof data !== 'object') return data;

    if (Object.prototype.hasOwnProperty.call(data, 'filters')) {
        data.filters = forceWizzyInStockOnlyOnFilters(data.filters);
    } else if (data.inStock != null && (Array.isArray(data.inStock) ? data.inStock.length > 0 : String(data.inStock).length > 0)) {
        var values = Array.isArray(data.inStock) ? data.inStock : [data.inStock];
        var wantsOos = values.some(function (v) {
            return String(v).toLowerCase() === 'false';
        });
        var wantsIn = values.some(function (v) {
            return String(v).toLowerCase() === 'true';
        });
        if (wantsOos && !wantsIn) {
            data.includeOutOfStock = 'true';
        } else if (wantsIn && !wantsOos) {
            data.includeOutOfStock = 'false';
        }
    } else {
        data.inStock = ['true'];
        data.includeOutOfStock = 'false';
    }

    return data;
}

/**
 * Read payload.filters whether Wizzy returned an object or a JSON string.
 * @param {object} payload
 * @returns {object|null}
 */
function readWizzyPayloadFilters(payload) {
    if (!payload || typeof payload !== 'object') return null;

    var filters = payload.filters;
    if (filters == null) return null;

    if (typeof filters === 'string') {
        try {
            filters = JSON.parse(filters);
            payload.filters = filters;
        } catch (e) {
            return null;
        }
    }

    if (!filters || typeof filters !== 'object' || Array.isArray(filters)) {
        return null;
    }

    return filters;
}

/**
 * Collection (Filter API, type CATEGORY_PAGE) already returns both Availability
 * buckets. Do not mutate that response.
 * @param {object} payload
 * @returns {boolean}
 */
function isWizzyCategoryPagePayload(payload) {
    var filters = readWizzyPayloadFilters(payload);
    if (!filters) return false;
    return String(filters.type || '').toUpperCase() === 'CATEGORY_PAGE';
}

/**
 * @param {object} option
 * @returns {string}
 */
function wizzyAvailabilityOptionKey(option) {
    if (!option || typeof option !== 'object') return '';
    var raw = option.key != null ? option.key : option.value;
    return String(raw).toLowerCase();
}

/**
 * @param {object[]} options
 * @param {string} wanted
 * @returns {boolean}
 */
function wizzyAvailabilityHasOption(options, wanted) {
    return options.some(function (option) {
        return wizzyAvailabilityOptionKey(option) === wanted;
    });
}

/**
 * Search API often returns only the bucket that has products. Wizzy then omits
 * that facet from leftFacets because data.length === 1, so Availability
 * disappears on SLP. Inject the missing bool so both checkboxes stay visible.
 * Do not mark either option selected, and do not write filters.inStock.
 * A real click is already isSelected / filters.inStock on Wizzy's payload.
 * @param {object} data AFTER_WIZZY_API_RESPONDED event payload
 * @returns {object}
 */
function ensureWizzySearchAvailabilityFacet(data) {
    if (!data || (data.api !== 'search' && data.api !== 'filter')) {
        return data;
    }

    var payload = data.response && data.response.payload;
    if (!payload || !Array.isArray(payload.facets)) {
        return data;
    }

    if (isWizzyCategoryPagePayload(payload)) {
        return data;
    }

    var inStockFacet = null;
    for (var i = 0; i < payload.facets.length; i++) {
        var facet = payload.facets[i];
        if (facet && String(facet.key || '').toLowerCase() === 'instock') {
            inStockFacet = facet;
            break;
        }
    }

    if (!inStockFacet) {
        return data;
    }

    if (!Array.isArray(inStockFacet.data)) {
        inStockFacet.data = [];
    }

    var options = inStockFacet.data;
    var hasIn = wizzyAvailabilityHasOption(options, 'true');
    var hasOos = wizzyAvailabilityHasOption(options, 'false');

    if (hasIn && hasOos) {
        return data;
    }

    if (!hasOos) {
        options.push({
            count: 0,
            label: 'Out of Stock',
            key: 'false',
            isSelected: false
        });
    }

    if (!hasIn) {
        options.push({
            count: 0,
            label: 'In Stock',
            key: 'true',
            isSelected: false
        });
    }

    options.sort(function (a, b) {
        var aKey = wizzyAvailabilityOptionKey(a);
        var bKey = wizzyAvailabilityOptionKey(b);
        if (aKey === bKey) return 0;
        if (aKey === 'false') return -1;
        if (bKey === 'false') return 1;
        return 0;
    });

    inStockFacet.data = options;
    inStockFacet.type = inStockFacet.type || 'bool-list';
    inStockFacet.position = inStockFacet.position || 'left';

    return data;
}

/**
 * Force Wizzy numbered pagination (not infinite scroll) and disable move-to-top widget.
 * @param {object} data
 * @returns {object}
 */
function applyWizzyNumberedPaginationConfig(data) {
    if (!data.search) {
        data.search = {};
    }

    if (!data.search.configs) {
        data.search.configs = {};
    }

    if (!data.search.configs.pagination) {
        data.search.configs.pagination = {};
    }

    data.search.configs.pagination.type = 'numbered';

    if (!data.search.configs.pagination.moveToTopWidget) {
        data.search.configs.pagination.moveToTopWidget = {};
    }

    data.search.configs.pagination.moveToTopWidget.add = false;

    return data;
}

/**
 * Reformat Wizzy's rendered page list to:
 * first, one before active, active, two after, last - with ellipses for gaps.
 * Does not call the Wizzy search API; only adjusts DOM Wizzy already rendered.
 */
function fixWizzyPaginationExpectedBehavior() {
    const pagesBefore = 1;
    const pagesAfter = 2;

    const pagination = document.querySelector(
        '.wizzy-search-pagination .wizzy-pagination-list'
    );

    if (!pagination) {
        return;
    }

    const activePageElement = pagination.querySelector('li.active[data-page]');

    const pageElements = Array.from(
        pagination.querySelectorAll('li[data-page]')
    );

    if (!activePageElement || pageElements.length === 0) {
        return;
    }

    const activePage = Number.parseInt(activePageElement.dataset.page, 10);

    const availablePageNumbers = pageElements
        .map(function (element) {
            return Number.parseInt(element.dataset.page, 10);
        })
        .filter(function (page) {
            return Number.isFinite(page) && page > 0;
        });

    if (!Number.isFinite(activePage) || availablePageNumbers.length === 0) {
        return;
    }

    const lastPage = Math.max.apply(null, availablePageNumbers);

    if (!Number.isFinite(lastPage) || lastPage <= 0) {
        return;
    }

    const pagesToDisplay = new Set([1, lastPage]);

    for (
        let page = activePage - pagesBefore;
        page <= activePage + pagesAfter;
        page += 1
    ) {
        if (page >= 1 && page <= lastPage) {
            pagesToDisplay.add(page);
        }
    }

    const sortedPages = Array.from(pagesToDisplay).sort(function (a, b) {
        return a - b;
    });

    const nextArrow = pagination.querySelector('.next-arrow');

    /*
     * Keep the original previous and next arrow elements.
     * Remove only the numbered pages and previously generated ellipses.
     */
    pagination
        .querySelectorAll('li:not(.pagination-arrow)')
        .forEach(function (element) {
            element.remove();
        });

    sortedPages.forEach(function (page, index) {
        const previousPage = sortedPages[index - 1];

        if (
            index > 0 &&
            Number.isFinite(previousPage) &&
            page - previousPage > 1
        ) {
            const dots = document.createElement('li');

            dots.className = 'wizzy-pagination-ellipsis';
            dots.setAttribute('aria-hidden', 'true');
            dots.innerHTML =
                '<span class="text wizzy-pagination-ellipsis__text">...</span>';

            pagination.insertBefore(dots, nextArrow || null);
        }

        const listItem = document.createElement('li');

        listItem.setAttribute('title', String(page));
        listItem.setAttribute('data-page', String(page));

        if (page === activePage) {
            listItem.classList.add('active');
            listItem.setAttribute('aria-current', 'page');
        }

        listItem.innerHTML =
            '<a href="#" aria-label="Page ' +
            page +
            '"><span class="text">' +
            page +
            '</span></a>';

        pagination.insertBefore(listItem, nextArrow || null);
    });
}

/** Remove only the `page` query param; preserve search, filters, sort, and other params. */
function wizzyRemovePageFromUrl() {
    const currentUrl = new URL(window.location.href);

    if (!currentUrl.searchParams.has('page')) {
        return;
    }

    currentUrl.searchParams.delete('page');

    const cleanUrl =
        currentUrl.pathname +
        (currentUrl.searchParams.toString()
            ? '?' + currentUrl.searchParams.toString()
            : '') +
        currentUrl.hash;

    window.history.replaceState(window.history.state, '', cleanUrl);
}

function applyWizzyRelevanceSort(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return;
    payload.sort = [{ field: 'relevance', order: 'asc' }];
}

/* Default sort only (contains `relevance`): these fields go before relevance, in this order.
 * A user-picked sort (price, newest, ...) has no relevance entry and is left untouched. */
/* merge_product: merged products have the higher value, so `desc` lists them first. */
var WIZZY_PRE_RELEVANCE_SORT_FIELDS = [
    { field: 'merge_product:float', order: 'desc' },
    { field: 'ordering:float', order: 'asc' }
];

function addWizzyOrderingSort(target) {
    if (!target || typeof target !== 'object') return;

    var sortWasString = typeof target.sort === 'string';
    var sort = target.sort;
    if (sortWasString) {
        try {
            sort = JSON.parse(sort);
        } catch (e) {
            return;
        }
    }
    if (!Array.isArray(sort)) return;

    var hasRelevance = sort.some(function (s) {
        return s && s.field === 'relevance';
    });
    if (!hasRelevance) return;

    var preRelevanceFieldNames = WIZZY_PRE_RELEVANCE_SORT_FIELDS.map(function (item) {
        return item.field;
    });
    var rest = sort.filter(function (s) {
        return !(s && preRelevanceFieldNames.indexOf(s.field) !== -1);
    });
    var relevanceIndex = rest.findIndex(function (s) {
        return s && s.field === 'relevance';
    });
    var preRelevance = WIZZY_PRE_RELEVANCE_SORT_FIELDS.map(function (item) {
        return { field: item.field, order: item.order };
    });

    sort = rest.slice(0, relevanceIndex).concat(preRelevance, rest.slice(relevanceIndex));
    target.sort = sortWasString ? JSON.stringify(sort) : sort;
}

window.onWizzyScriptLoaded = function () {
    if (window.__aoneWizzyScriptHooksBound) return;
    window.__aoneWizzyScriptHooksBound = true;

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
        function (data) {
            setTimeout(syncAutocompleteWidth, 2);
            setTimeout(syncAutocompleteWidth, 50);
            scheduleHydrateWizzyCardMeta(80);
            scheduleHydrateWizzyCardMeta(250);
            return data;
        }
    );

    //not working Yash
      if (window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED) {
        window.wizzyConfig.events.registerEvent(
            window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
            function (data) {
                if (data && typeof data === 'object') {
                    data.variantsGroupBy = "virtualGroupId";
                }
                return data;
            }
        );
    }
    
window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
        const autocomplete = document.querySelector(
            ".wizzy-autocomplete-wrapper"
        );
        if (data && typeof data === 'object') {
            data.variantsGroupBy = "virtualGroupId"; 
            addWizzyOrderingSort(data);
        }

        if (autocomplete) {
            autocomplete.style.display = "none";
        }

        const collectionHeading = document.querySelector(
            ".plp-collection__heading"
        );

        if (collectionHeading) {
            collectionHeading.style.display = "none";
        }
        // forceWizzyInStockOnlyRequest(data);

        return data;
    }
);

    // window.wizzyConfig.events.registerEvent(
    //     window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    //     function (data) {
    //         return forceWizzyInStockOnlyRequest(data);
    //     }
    // );


    // window.wizzyConfig.events.registerEvent(
    //     window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    //     function (data) {
    //         if (data && typeof data === 'object') {
    //             data.variantsGroupBy = "virtualGroupId";
    //         }
    //         return data;
    //     }
    // );
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
        function (data) {
            if (!data || typeof data !== 'object') return data;

            // Collection/filter API reads only the filters JSON string.
            // A sibling variantsGroupBy is ignored, which is why search groups and collection does not.
            var filtersWereString = typeof data.filters === 'string';
            var filters = null;
            if (filtersWereString) {
                try {
                    filters = JSON.parse(data.filters);
                } catch (e) {
                    filters = null;
                }
            } else if (data.filters && typeof data.filters === 'object' && !Array.isArray(data.filters)) {
                filters = data.filters;
            }

            if (filters && typeof filters === 'object' && !Array.isArray(filters)) {
                filters.variantsGroupBy = "virtualGroupId";
                // applyWizzyRelevanceSort(filters);
                 addWizzyOrderingSort(filters);
                data.filters = filtersWereString ? JSON.stringify(filters) : filters;
            } else {
                // applyWizzyRelevanceSort(data);
                 addWizzyOrderingSort(data);
            }

            data.variantsGroupBy = "virtualGroupId";
            return data;
        }
    );
     
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function (products) {
            products.forEach(function (product) {
                var attributes = product.attributes;
                var mergedTitle = '';
                if (attributes) {
                    attributes.forEach(function (attr) {
                        if (!product.handle && (attr.id === 'product_handle' || attr.id === 'handle')) {
                            var handleValue = readWizzyAttributeValue(attr);
                            if (handleValue) product.handle = handleValue;
                        }
                        if (!product.sku && isWizzySkuAttribute(attr)) {
                            var skuValue = readWizzyAttributeValue(attr);
                            if (skuValue) product.sku = skuValue;
                        }
                        if (!mergedTitle && isWizzyMergedTitleAttribute(attr)) {
                            mergedTitle = readWizzyAttributeValue(attr);
                        }
                        if (!product.productType) {
                            var attrId = String(attr.id || attr.name || '').toLowerCase();
                            if (
                                attrId === 'product_type' ||
                                attrId === 'producttype' ||
                                attrId === 'product type' ||
                                attrId === 'type'
                            ) {
                                var typeValue = readWizzyAttributeValue(attr);
                                if (typeValue) product.productType = typeValue;
                            }
                        }
                    });
                }
                if (!product.productType) {
                    product.productType =
                        product.product_type ||
                        product.type ||
                        product.category ||
                        product.productCategory ||
                        '';
                }
                var typeKey = String(product.productType || '')
                    .trim()
                    .toLowerCase();
                var nameKey = String(product.name || product.title || '')
                    .trim()
                    .toLowerCase();
                var isCharm =
                    typeKey === 'charm' ||
                    typeKey === 'charms' ||
                    /(^|[^a-z])charm(s)?([^a-z]|$)/.test(typeKey) ||
                    /(^|[^a-z])charm(s)?([^a-z]|$)/.test(nameKey);
                if (isCharm) {
                    product.isCharmProduct = true;
                    if (!product.productType) product.productType = 'Charm';
                }
                // Charm detection above must keep using the original product name.
                if (mergedTitle) {
                    product.name = mergedTitle;
                    product.isMergedProduct = true;
                }
                if (!product.sku && product.SKU) {
                    product.sku = product.SKU;
                }
                if (!product.sku && product.variants && product.variants.length && product.variants[0].sku) {
                    product.sku = product.variants[0].sku;
                }
                // Ensure handle exists for Quick View / weight fetch on search + collection.
                // Search payloads sometimes omit `handle` while still providing a product URL.
                if (!product.handle) {
                    var urlCandidate =
                        product.url ||
                        product.groupUrl ||
                        product.productUrl ||
                        product.link ||
                        product.slug ||
                        '';
                    try {
                        var path = String(urlCandidate);
                        var m = path.match(/\/products\/([^/?#]+)/);
                        if (m && m[1]) {
                            product.handle = decodeURIComponent(m[1]);
                        } else if (path && path.indexOf('/') === -1 && path.indexOf(' ') === -1) {
                            // Some Wizzy payloads put a bare handle in `slug`
                            product.handle = path;
                        }
                    } catch (e) {
                        /* noop */
                    }
                }
            });
            setTimeout(applyWizzyLowStockBadges, 150);
            setTimeout(syncWizzyProductHandlesInDom, 0);
            setTimeout(initWizzySearchViewSwitcher, 0);
            // Shopify qty + Coming Soon; WMS min weight.
            scheduleHydrateWizzyCardMeta(200);
            return products;
        }
    );  

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
        function (data) {
//             data.credentials{
//     "apiKey": "OVBkVXQyclVqVlVDTFIwNTFibG52TFkreGQ2U1RzWkEvNDhVekJZRkNabzBsdkdHVlhyRUJteGh1eUtaMXR6S25lMnd0Y1VXRXZEbUV6OWd3MXpSYnZNQVVpaklIWWVyd0ViTU9scjgwNlU9",
//     "storeId": "d682dbd647a511f181f50a0c8095feae"
// };


            // const header = document.querySelector('.aone-header__main-inner');

// function toggleHeader() {
//   const filterOpen = document.body.classList.contains('wizzy-filters-overlay');

//   if (header) {
//     header.style.display = filterOpen ? 'none' : '';
//   }
// }

// new MutationObserver(toggleHeader).observe(document.body, {
//   attributes: true,
//   attributeFilter: ['class']
// });

// toggleHeader();

            data.search.configs.facets.showPriceInputRangeFields = true;
            data.filters.configs.layout = 'v1';
            data.search.configs.facets.leftFacets.mobileCollapsible = !0;
            window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = !0;
            data.search.configs.facets.leftFacets.defaultCollapsed = !0;

            applyWizzyNumberedPaginationConfig(data);

            return data;
        }
    );
        window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
        function (data) {
//             data.credentials{
//     "apiKey": "OVBkVXQyclVqVlVDTFIwNTFibG52TFkreGQ2U1RzWkEvNDhVekJZRkNabzBsdkdHVlhyRUJteGh1eUtaMXR6S25lMnd0Y1VXRXZEbUV6OWd3MXpSYnZNQVVpaklIWWVyd0ViTU9scjgwNlU9",
//     "storeId": "d682dbd647a511f181f50a0c8095feae"
// };
            data.search.configs.facets.showPriceInputRangeFields = true;
            data.filters.configs.layout = 'v1';
            window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = !0;
            data.search.configs.facets.leftFacets.mobileCollapsible = !0;
            data.search.configs.facets.leftFacets.defaultCollapsed = !0;

            applyWizzyNumberedPaginationConfig(data);

            return data;
        }
    );

    if (!window.__customWizzyPaginationInitialized) {
        window.__customWizzyPaginationInitialized = true;

        window.wizzyConfig.events.registerEvent(
            window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
            function (data) {
                try {
                    wizzyRemovePageFromUrl();

                    fixWizzyPaginationExpectedBehavior();

                    window.requestAnimationFrame(function () {
                        fixWizzyPaginationExpectedBehavior();
                    });

                    window.setTimeout(fixWizzyPaginationExpectedBehavior, 300);

                    window.setTimeout(fixWizzyPaginationExpectedBehavior, 1000);
                } catch (paginationError) {
                    console.error(
                        'Unable to format Wizzy pagination:',
                        paginationError
                    );
                }

                // Ensure availability hydration runs after every Wizzy render
                // (search + collection + filter + pagination). Cards are now in DOM.
                scheduleHydrateWizzyCardMeta(250);

                return data;
            }
        );
    }

    // Update PLP item count from Wizzy filter/search API payload.total
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
        function (data) {
            if (data.api !== 'filter' && data.api !== 'search') return data;

            data = ensureWizzySearchAvailabilityFacet(data);

            var total = data.response && data.response.payload && data.response.payload.total;
            if (total != null) {
                setTimeout(function () {
                    var meta = document.querySelector('.plp-collection__meta');
                    if (meta) {
                        meta.textContent = total + (total === 1 ? ' item' : ' items');
                    }
                }, 100);
            }

            /* Default in-stock filter re-renders results — restore Grid / Order sheet. */
            setTimeout(function () {
                initWizzySearchViewSwitcher();
            }, 60);

            return data;
        }
    );

    var lowStockTimer;
    if (!window.__aoneWizzyCardHydrateObserverBound) {
        window.__aoneWizzyCardHydrateObserverBound = true;
        new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var added = mutations[i].addedNodes;
                if (!added || !added.length) continue;
                for (var j = 0; j < added.length; j++) {
                    if (addedNodeHasWizzyCard(added[j])) {
                        wizzyCardHydratePending = true;
                        break;
                    }
                }
                if (wizzyCardHydratePending) break;
            }
            clearTimeout(lowStockTimer);
            lowStockTimer = setTimeout(function () {
                applyWizzyLowStockBadges();
                if (!wizzyCardHydratePending) return;
                wizzyCardHydratePending = false;
                // Wizzy replaced/inserted card DOM (VIEW_RENDERED does not always
                // fire on executeCachedListing / renderCached during Back).
                // Trigger the shared hydrate; loadCurrentProductWeights({preferCache:true})
                // reuses the products-batch cache and paints CURRENT DOM.
                scheduleHydrateWizzyCardMeta(150);
            }, 200);
        }).observe(document.body, { childList: true, subtree: true });
    }
};

var WIZZY_LOW_STOCK_THRESHOLD = 5;
var wizzyStockCache = {};
var wizzyStockPending = {};
/** @type {Record<string, number|null>} sku(lower) -> grams (null = known missing) */
var wizzyWeightCache = {};
var wizzyWeightHydrateTimer = null;
var wizzyWeightRestoreTimer = null;
var wizzyWeightInFlightKey = '';
/** @type {Promise<Record<string, number>>|null} */
var wizzyWeightInFlightPromise = null;
var wizzyWeightRestoreObserver = null;
/**
 * productId -> { weight, qty, rawQty, storefrontStatus, qtySource }
 * Qty / Coming Soon: Shopify inventory (?view=qty). Min weight: WMS when available.
 * @type {Record<string, { weight: number|null, qty: number|null, rawQty?: number|null, storefrontStatus?: string, qtySource?: string }>}
 */
var wizzyMetaCache = {};
var wizzyMetaHydrateTimer = null;
/**
 * Survives later unrelated childList mutations in the same debounce window.
 * Without this, a non-card mutation can cancel the timer that would have
 * hydrated Wizzy cards inserted a few milliseconds earlier (PDP → Back).
 */
var wizzyCardHydratePending = false;
/** Grid cards + order-sheet rows inside Wizzy results (collection + search + autocomplete). */
var WIZZY_META_CARD_SELECTOR =
    '.wizzy-search-results-list .plp-card[data-product-id], .wizzy-search-results-list .inventory-product-row[data-product-id], .wizzy-autocomplete-wrapper .plp-card[data-product-id]';
var WIZZY_META_EMPTY_DISPLAY = 'N/A';
var WIZZY_META_LOADING_DISPLAY = 'Checking...';
var WIZZY_BUTTON_LOADING_DISPLAY = 'Checking availability...';
var WIZZY_BUTTON_ADD_TO_CART = 'ADD TO CART';

/**
 * True when a MutationObserver added node IS a Wizzy card container/list,
 * or CONTAINS a Wizzy card. Fixes the intermittent PDP → Back bug where
 * Wizzy's executeCachedListing / renderCached path replaces .plp-card articles
 * inside <li class="wizzy-result-product"> and the previous observer test
 * missed the inserted <li> (querySelector never matches the node it is called on).
 *
 * Detect both shapes Wizzy inserts:
 *   1. The added node itself is  <li class="wizzy-result-product">
 *      or  <ul class="wizzy-search-results-list">
 *   2. The added node contains   .plp-card[data-product-id] / .inventory-product-row[data-product-id]
 *      or a nested               .wizzy-result-product
 *
 * @param {Node} node
 * @returns {boolean}
 */
function addedNodeHasWizzyCard(node) {
    if (!(node instanceof Element)) return false;
    if (
        typeof node.matches === 'function' &&
        node.matches(
            '.plp-card[data-product-id], .inventory-product-row[data-product-id], .wizzy-result-product, .wizzy-search-results-list'
        )
    ) {
        return true;
    }
    return !!(
        typeof node.querySelector === 'function' &&
        node.querySelector(
            '.plp-card[data-product-id], .inventory-product-row[data-product-id], .wizzy-result-product'
        )
    );
}

/**
 * Live Wizzy cards for one parent product id.
 * Called AFTER async work so the paint targets the DOM the user is looking at,
 * not a card instance captured before products-batch resolved / cache was hit.
 * Uses the existing WIZZY_META_CARD_SELECTOR + normalizeWizzyProductId, so no
 * competing selector or id-normalization is introduced.
 *
 * @param {string} productId
 * @returns {HTMLElement[]}
 */
function getCurrentWizzyCardsForProduct(productId) {
    var normalizedTarget = normalizeWizzyProductId(productId);
    if (!normalizedTarget) return [];
    var cards = [];
    document.querySelectorAll(WIZZY_META_CARD_SELECTOR).forEach(function (card) {
        if (!(card instanceof HTMLElement)) return;
        if (!card.isConnected) return;
        if (normalizeWizzyProductId(card.getAttribute('data-product-id')) !== normalizedTarget) return;
        cards.push(card);
    });
    return cards;
}
var WIZZY_BUTTON_COMING_SOON = 'COMING SOON';
var WIZZY_BUTTON_ALL_IN_CART = 'All Available Qty in Cart';
var WIZZY_QTY_SOURCE_SHOPIFY = 'shopify';
var WIZZY_WMS_REQUEST_TIMEOUT_MS = 20000;
/** Fallback-only: max simultaneous per-parent products-batch POSTs when weight-service is absent. */
var WIZZY_MAX_CONCURRENT_PRODUCT_REQUESTS = 5;
var wizzyMetaRestoreTimer = null;
var wizzyMetaInFlightKey = '';
/** @type {Promise<Record<string, { weight: number|null, qty: number|null }>>|null} */
var wizzyMetaInFlightPromise = null;
/** @type {Record<string, Promise<Record<string, { weight: number|null, qty: number|null }>>>} */
var wizzyMetaInFlightByProductId = {};
var wizzyMetaRestoreObserver = null;
var wizzyMetaPageshowBound = false;
var wizzyMetaCartInventoryBound = false;
/** True while applying cart-aware paints so MutationObservers do not fight with stale cache restores. */
var wizzyMetaApplyingCartAware = false;
/** Lightweight generation token so stale Wizzy batch responses cannot overwrite newer paints. */
var wizzyMetaRequestGeneration = 0;
/** Monotonic cart-mutation generation so older cart-aware paints cannot overwrite newer ones. */
var wizzyMetaCartGeneration = 0;
/**
 * Card productId -> every Shopify product id of its merge group (card id first).
 * Filled from ?view=qty (_product_id + _linked_product_ids). Non-merged cards stay [productId].
 * @type {Record<string, string[]>}
 */
var wizzyGroupProductIdsById = {};

function getWizzyWmsAvailabilityApi() {
    return window.WMSInventory || window.AOneWmsAvailability || null;
}

function isWizzySkuAttribute(attr) {
    if (!attr || !attr.id) return false;
    var id = String(attr.id).toLowerCase();
    return id === 'sku' || id === 'variant_sku' || id === 'product_sku' || id.indexOf('sku') !== -1;
}

function isWizzyMergedTitleAttribute(attr) {
    return !!attr && String(attr.id || '').trim().toLowerCase() === 'product_merged_title_info';
}

function readWizzyAttributeValue(attr) {
    try {
        if (!attr || !attr.values || !attr.values.length) return '';
        var first = attr.values[0];
        if (first == null) return '';
        if (typeof first === 'string' || typeof first === 'number') return String(first).trim();
        if (first.value != null) {
            if (Array.isArray(first.value)) return String(first.value[0] || '').trim();
            return String(first.value).trim();
        }
    } catch (e) {
        /* noop */
    }
    return '';
}

/** Backfill data-product-handle on Wizzy cards from product links when missing. */
function syncWizzyProductHandlesInDom() {
    document
        .querySelectorAll(
            '.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .wizzy-search-results-list [data-order-sheet-item], .wizzy-autocomplete-wrapper .plp-card'
        )
        .forEach(function (card) {
            if (!(card instanceof HTMLElement)) return;
            var existing = String(card.getAttribute('data-product-handle') || '').trim();
            // Treat empty / unrendered Mustache placeholders as missing.
            if (existing && existing.indexOf('[[') === -1) return;
            var link = card.querySelector(
                'a.plp-card__media-link, a.inventory-product-row__media-link, a[href*="/products/"]'
            );
            if (!(link instanceof HTMLAnchorElement)) {
                var item = card.closest('.plp-product-grid__item, .wizzy-result-product, [data-order-sheet-item]');
                link = item ? item.querySelector('a[href*="/products/"]') : null;
            }
            if (!(link instanceof HTMLAnchorElement)) return;
            var match = String(link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
            if (!match || !match[1]) return;
            var handle = decodeURIComponent(match[1]).trim();
            if (!handle || handle.indexOf('[[') !== -1) return;
            card.setAttribute('data-product-handle', handle);
            var row = card.matches('[data-order-sheet-row], .inventory-product-row')
                ? card
                : card.querySelector('[data-order-sheet-row], .inventory-product-row');
            if (row instanceof HTMLElement) row.setAttribute('data-product-handle', handle);
            var orderItem = card.closest('[data-order-sheet-item], [data-plp-inventory-item]');
            if (orderItem instanceof HTMLElement) orderItem.setAttribute('data-product-handle', handle);
        });
}

function getWizzyWeightApiConfig() {
    // Prefer live theme WMS config (same source collection / weight-service uses).
    try {
        var liveCfg = window.AOneWmsConfig;
        if (liveCfg && liveCfg.enabled !== false && liveCfg.apiBaseUrl) {
            return {
                apiBaseUrl: String(liveCfg.apiBaseUrl).replace(/\/+$/, ''),
                weightsPath: '/public/products',
                timeoutMs: Math.max(
                    WIZZY_WMS_REQUEST_TIMEOUT_MS,
                    Number(liveCfg.timeoutMs) || WIZZY_WMS_REQUEST_TIMEOUT_MS
                ),
            };
        }
    } catch (liveErr) {
        /* noop */
    }

    // Same sources collection uses: theme batch config, then PLP section weight config.
    var batchEl = document.querySelector('[data-batch-weight-config]');
    if (batchEl) {
        try {
            var batch = JSON.parse(batchEl.textContent || '{}');
            if (batch && batch.enabled && batch.baseUrl) {
                return {
                    apiBaseUrl: String(batch.baseUrl).replace(/\/+$/, ''),
                    weightsPath: '/public/products',
                    timeoutMs: Math.max(
                        WIZZY_WMS_REQUEST_TIMEOUT_MS,
                        Number(batch.timeoutMs) || WIZZY_WMS_REQUEST_TIMEOUT_MS
                    ),
                };
            }
        } catch (e) {
            /* noop */
        }
    }

    var sectionEl = document.querySelector(
        '[data-plp-fetch-weight-config-section], [data-plp-fetch-weight-config], [data-pdp-fetch-weight-config]'
    );
    if (sectionEl) {
        try {
            var section = JSON.parse(sectionEl.textContent || '{}');
            var base = section && (section.apiBaseUrl || section.baseUrl);
            if (base) {
                return {
                    apiBaseUrl: String(base).replace(/\/+$/, ''),
                    weightsPath: String(section.weightsPath || '/public/products').replace(/\/+$/, '') || '/public/products',
                    timeoutMs: WIZZY_WMS_REQUEST_TIMEOUT_MS,
                };
            }
        } catch (e2) {
            /* noop */
        }
    }

    return null;
}

function isBatchWeightApiEnabled() {
    return !!getWizzyWeightApiConfig();
}

function getAvailableStockForVariants(url) {
    try {
        var cleanUrl = new URL(url, window.location.origin);
        cleanUrl.search = '';
        cleanUrl.searchParams.set('view', 'qty');
        var qtyUrl = cleanUrl.toString();

        if (wizzyStockCache[qtyUrl]) {
            return Promise.resolve(wizzyStockCache[qtyUrl]);
        }
        if (wizzyStockPending[qtyUrl]) {
            return wizzyStockPending[qtyUrl];
        }

        wizzyStockPending[qtyUrl] = fetch(qtyUrl)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('HTTP error! Status: ' + response.status);
                }
                return response.text();
            })
            .then(function (rawText) {
                var jsonData = JSON.parse(rawText);
                wizzyStockCache[qtyUrl] = jsonData;
                return jsonData;
            })
            .catch(function (error) {
                console.error('Failed to fetch custom template JSON:', error);
                return {};
            })
            .finally(function () {
                delete wizzyStockPending[qtyUrl];
            });

        return wizzyStockPending[qtyUrl];
    } catch (e) {
        console.error('Invalid URL provided to the function:', e);
        return Promise.resolve({});
    }
}

/**
 * Resolve product URL used for Shopify ?view=qty inventory.
 * @param {HTMLElement} card
 * @returns {string}
 */
function getWizzyCardProductUrl(card) {
    if (!(card instanceof HTMLElement)) return '';
    var handle = String(card.getAttribute('data-product-handle') || '').trim();
    if (handle && handle.indexOf('[[') === -1) {
        var root = '/';
        try {
            if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
                root = window.Shopify.routes.root;
            }
        } catch (e) {
            /* noop */
        }
        if (root.slice(-1) !== '/') root += '/';
        return root + 'products/' + encodeURIComponent(handle);
    }
    var link = card.querySelector(
        'a.plp-card__media-link, a.inventory-product-row__media-link, a[href*="/products/"]'
    );
    if (link instanceof HTMLAnchorElement) {
        return String(link.href || link.getAttribute('href') || '').trim();
    }
    var item = card.closest('.plp-product-grid__item, .wizzy-result-product, [data-order-sheet-item]');
    var itemLink = item ? item.querySelector('a[href*="/products/"]') : null;
    if (itemLink instanceof HTMLAnchorElement) {
        return String(itemLink.href || itemLink.getAttribute('href') || '').trim();
    }
    return '';
}

/**
 * Shopify inventory from product.qty view — total product qty (sum of variants).
 * Merged products use the whole group total (this product + custom.linked_products).
 * @param {Record<string, unknown>|null|undefined} stockMap
 * @param {string|null|undefined} variantId
 * @returns {number}
 */
function resolveShopifyTotalQtyFromStockMap(stockMap, variantId) {
    if (!stockMap || typeof stockMap !== 'object') return 0;

    var groupTotal = Number(stockMap._group_total_inventory);
    if (Number.isFinite(groupTotal) && groupTotal >= 0) return Math.floor(groupTotal);

    var total = Number(stockMap._total_inventory);
    if (Number.isFinite(total) && total >= 0) return Math.floor(total);

    if (variantId != null && String(variantId).trim() !== '') {
        var key = String(variantId).trim();
        if (Object.prototype.hasOwnProperty.call(stockMap, key)) {
            var variantQty = Number(stockMap[key]);
            if (Number.isFinite(variantQty)) return Math.max(0, Math.floor(variantQty));
        }
    }

    var sum = 0;
    var hasVariantQty = false;
    Object.keys(stockMap).forEach(function (k) {
        if (String(k).charAt(0) === '_') return;
        var n = Number(stockMap[k]);
        if (!Number.isFinite(n)) return;
        hasVariantQty = true;
        sum += Math.max(0, Math.floor(n));
    });
    return hasVariantQty ? sum : 0;
}

/**
 * Merge WMS min-weight with Shopify qty.
 * Min weight stays API-owned and is independent of Shopify qty / Coming Soon.
 * @param {{ weight?: number|null, loading?: boolean }|null|undefined} weightMeta
 * @param {number} shopifyQty
 * @returns {{ weight: number|null, qty: number, rawQty: number, storefrontStatus: string, qtySource: string, loading?: boolean }}
 */
function mergeWizzyMetaWithShopifyQty(weightMeta, shopifyQty) {
    var qty = Math.max(0, Math.floor(Number(shopifyQty) || 0));
    var weightN = Number(weightMeta && weightMeta.weight);
    var weight = Number.isFinite(weightN) && weightN > 0 ? weightN : null;
    return {
        weight: weight,
        qty: qty,
        rawQty: qty,
        storefrontStatus: qty > 0 ? 'AVAILABLE' : 'COMING_SOON',
        qtySource: WIZZY_QTY_SOURCE_SHOPIFY,
    };
}

/**
 * Fetch Shopify inventory for one search card (?view=qty).
 * @param {HTMLElement} card
 * @returns {Promise<number>}
 */
function fetchShopifyQtyForWizzyCard(card) {
    var url = getWizzyCardProductUrl(card);
    if (!url) return Promise.resolve(0);

    var variantInput = card.querySelector('input[name="id"]');
    var variantId =
        variantInput instanceof HTMLInputElement ? String(variantInput.value || '').trim() : '';

        return getAvailableStockForVariants(url).then(function (stockMap) {
        var resolvedSku = stockMap && stockMap._sku != null ? String(stockMap._sku).trim() : '';
        if (resolvedSku) setWizzyCardSku(card, resolvedSku);
        recordWizzyGroupProductIds(card.getAttribute('data-product-id'), stockMap);

        // Do not paint Shopify interim weight — keep Checking... until products-batch.
        return resolveShopifyTotalQtyFromStockMap(stockMap, variantId);
    });
}

function applyWizzyMinWeightDisplay(card, grams, options) {
    var opts = options || {};
    var minWeightValue = card.querySelector('[data-wizzy-min-weight-value], [data-min-weight-value]');
    if (!minWeightValue) return;

    var n = Number(grams);
    var sku = readWizzyCardSku(card);
    if (Number.isFinite(n) && n > 0) {
        var rounded = Math.round(n * 1000) / 1000;
        minWeightValue.textContent = rounded.toFixed(3) + ' g';
        card.setAttribute('data-min-weight-state', 'ready');
        minWeightValue.removeAttribute('data-min-weight-loading');
        minWeightValue.removeAttribute('data-min-weight-pending');
        minWeightValue.setAttribute('data-state', 'ready');
        if (!opts.interim) {
            card.setAttribute('data-weight-hydrated', 'true');
            card.setAttribute('data-wizzy-weight-ready', 'true');
            if (sku) storeWizzyCachedWeight(sku, rounded);
        }
    } else if (!opts.interim) {
        minWeightValue.textContent = WIZZY_META_EMPTY_DISPLAY;
        card.setAttribute('data-min-weight-state', 'error');
        card.setAttribute('data-weight-hydrated', 'true');
        card.setAttribute('data-wizzy-weight-ready', 'true');
        if (sku) storeWizzyCachedWeight(sku, null);
        minWeightValue.removeAttribute('data-min-weight-loading');
        minWeightValue.removeAttribute('data-min-weight-pending');
        minWeightValue.setAttribute('data-state', 'error');
    }
    var row = card.querySelector('.plp-card__min-weight');
    if (row) {
        row.setAttribute('data-min-weight-state', card.getAttribute('data-min-weight-state') || 'error');
    }
}

function storeWizzyCachedWeight(sku, grams) {
    var key = String(sku || '')
        .trim()
        .toLowerCase();
    if (!key) return;
    var n = Number(grams);
    wizzyWeightCache[key] = Number.isFinite(n) && n > 0 ? n : null;
}

function lookupWizzyCachedWeight(sku) {
    var key = String(sku || '')
        .trim()
        .toLowerCase();
    if (!key || !Object.prototype.hasOwnProperty.call(wizzyWeightCache, key)) return undefined;
    return wizzyWeightCache[key];
}

function scheduleHydrateWizzyCardMinWeights(delayMs) {
    scheduleHydrateWizzyCardMeta(delayMs);
}

function scheduleHydrateWizzyCardAvailableQty(delayMs) {
    scheduleHydrateWizzyCardMeta(delayMs);
}

/**
 * Unified schedule: Shopify qty + Coming Soon, WMS min weight.
 * All Wizzy triggers must go through this timer — never call the network directly.
 * @param {number} [delayMs]
 */
function scheduleHydrateWizzyCardMeta(delayMs) {
    ensureWizzyMetaPageshowBinding();
    window.clearTimeout(wizzyMetaHydrateTimer);
    // Coalesce rapid Wizzy lifecycle events into one hydrateWizzyCardMeta → one shared API call.
    var wait = delayMs == null ? 300 : delayMs;
    wizzyMetaHydrateTimer = window.setTimeout(function () {
        wizzyMetaHydrateTimer = null;
        hydrateWizzyCardMeta();
    }, wait);
}

/** Re-paint when weight-service resets cards to loading after an abort. */
function restoreWizzyWeightsFromCache() {
    restoreWizzyMetaFromCache();
}

function ensureWizzyWeightRestoreObserver() {
    if (wizzyWeightRestoreObserver) return;
    var root =
        document.querySelector('.wizzy-search-results-list') ||
        document.querySelector('.wizzy-search-wrapper') ||
        document.body;
    wizzyWeightRestoreObserver = new MutationObserver(function () {
        if (wizzyMetaApplyingCartAware) return;
        window.clearTimeout(wizzyWeightRestoreTimer);
        wizzyWeightRestoreTimer = window.setTimeout(function () {
            wizzyWeightRestoreTimer = null;
            restoreWizzyWeightsFromCache();
        }, 80);
    });
    wizzyWeightRestoreObserver.observe(root, {
        childList: true,
        subtree: true,
        // Do not observe characterData — weight-service cart-aware text updates
        // would otherwise trigger stale raw-cache restores.
        attributes: true,
        attributeFilter: ['data-min-weight-state', 'data-weight-hydrated', 'data-weight-sku'],
    });
}

function setWizzyCardSku(card, sku) {
    var resolved = String(sku || '').trim();
    if (!resolved || !card) return '';
    card.setAttribute('data-weight-sku', resolved);
    var skuEl = card.querySelector('.plp-card__sku');
    if (card.getAttribute('data-merged-product') === 'true') {
        if (skuEl) skuEl.remove();
        return resolved;
    }
    if (!skuEl) {
        var body = card.querySelector('.plp-card__body');
        var title = card.querySelector('.plp-card__title');
        if (body) {
            skuEl = document.createElement('p');
            skuEl.className = 'plp-card__sku';
            if (title) body.insertBefore(skuEl, title);
            else body.insertBefore(skuEl, body.firstChild);
        }
    }
    if (skuEl) skuEl.textContent = 'SKU: ' + resolved;
    return resolved;
}

function readWizzyCardSku(card) {
    var fromAttr = String(card.getAttribute('data-weight-sku') || '').trim();
    if (fromAttr) return fromAttr;
    var skuEl = card.querySelector('.plp-card__sku, .inventory-product-row__sku-value');
    if (!skuEl) return '';
    var text = String(skuEl.textContent || '');
    var match = text.match(/SKU:\s*(.+)$/i);
    return String(match ? match[1] : text).trim();
}

/**
 * Same batch endpoint collection uses (weight-service / plp-table-details):
 * POST {base}/public/products/weights/batch  body: { skus: [...] }
 */
function fetchWizzyBatchMinWeights(skus, cfg) {
    var path = String(cfg.weightsPath || '/public/products').replace(/\/+$/, '') + '/weights/batch';
    var base = String(cfg.apiBaseUrl || '').replace(/\/+$/, '');
    var url = base + path;
    var headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    try {
        if (new URL(url, window.location.origin).hostname.toLowerCase().indexOf('ngrok') >= 0) {
            headers['ngrok-skip-browser-warning'] = 'true';
        }
    } catch (e) {
        /* noop */
    }

    var requestKey = skus
        .map(function (s) {
            return String(s).toLowerCase();
        })
        .sort()
        .join('|');

    if (wizzyWeightInFlightPromise && wizzyWeightInFlightKey === requestKey) {
        return wizzyWeightInFlightPromise;
    }

    // Longer than shared 8s timeout - slow APIs were leaving "..." then aborting.
    var timeoutMs = Math.max(12000, Number(cfg.timeoutMs) || 12000);

    function once() {
        var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timeoutId = window.setTimeout(function () {
            if (controller) controller.abort();
        }, timeoutMs);

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: headers,
            body: JSON.stringify({ skus: skus }),
            signal: controller ? controller.signal : undefined,
        })
            .then(function (res) {
                if (!res.ok) throw new Error('Weight API HTTP ' + res.status);
                return res.json();
            })
            .then(function (payload) {
                return parseWizzyBatchMinWeightMap(payload, skus);
            })
            .finally(function () {
                window.clearTimeout(timeoutId);
            });
    }

    wizzyWeightInFlightKey = requestKey;
    wizzyWeightInFlightPromise = once()
        .catch(function () {
            // One retry for transient aborts / timeouts
            return once();
        })
        .finally(function () {
            if (wizzyWeightInFlightKey === requestKey) {
                wizzyWeightInFlightKey = '';
                wizzyWeightInFlightPromise = null;
            }
        });

    return wizzyWeightInFlightPromise;
}

function wizzyToFiniteNumber(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string') {
        var match = value.replace(/,/g, '').match(/-?\d+(\.\d+)?/);
        if (!match) return null;
        var n = Number(match[0]);
        return Number.isFinite(n) ? n : null;
    }
    return null;
}

function extractWizzyMinFromNode(node) {
    if (node == null) return null;
    var direct = wizzyToFiniteNumber(node);
    if (direct != null && direct > 0) return direct;
    if (Array.isArray(node)) {
        var min = null;
        for (var i = 0; i < node.length; i++) {
            var n = extractWizzyMinFromNode(node[i]);
            if (n == null || n <= 0) continue;
            min = min == null ? n : Math.min(min, n);
        }
        return min;
    }
    if (typeof node !== 'object') return null;
    var preferred = [
        'minWeight',
        'min_weight',
        'minimumWeight',
        'minimum_weight',
        'minWeightGrams',
        'min_weight_grams',
        'weight',
        'weight_g',
        'gross_weight',
        'net_weight',
    ];
    for (var p = 0; p < preferred.length; p++) {
        if (!(preferred[p] in node)) continue;
        var fromPref = extractWizzyMinFromNode(node[preferred[p]]);
        if (fromPref != null && fromPref > 0) return fromPref;
    }
    for (var key in node) {
        if (!Object.prototype.hasOwnProperty.call(node, key)) continue;
        var norm = String(key || '')
            .replace(/[\s_-]+/g, '')
            .toLowerCase();
        if (norm.indexOf('weight') === -1) continue;
        if (norm.indexOf('min') >= 0 || norm === 'weight') {
            var fromKey = wizzyToFiniteNumber(node[key]);
            if (fromKey != null && fromKey > 0) return fromKey;
        }
    }
    var listKeys = ['availableWeights', 'availableOptions', 'weights', 'items', 'results', 'data', 'entries'];
    for (var l = 0; l < listKeys.length; l++) {
        if (!(listKeys[l] in node)) continue;
        var fromList = extractWizzyMinFromNode(node[listKeys[l]]);
        if (fromList != null) return fromList;
    }
    return null;
}

function extractWizzySkuFromObject(obj) {
    if (!obj || typeof obj !== 'object') return '';
    var keys = ['sku', 'SKU', 'productSku', 'product_sku', 'variantSku', 'variant_sku', 'itemCode', 'item_code', 'code'];
    for (var i = 0; i < keys.length; i++) {
        if (!(keys[i] in obj)) continue;
        var sku = String(obj[keys[i]] || '').trim();
        if (sku) return sku;
    }
    return '';
}

function parseWizzyBatchMinWeightMap(payload, requestedSkus) {
    var result = {};
    var requested = {};
    (requestedSkus || []).forEach(function (s) {
        requested[String(s).toLowerCase()] = true;
    });

    function assign(sku, value) {
        var normalized = String(sku || '').trim();
        if (!normalized) return;
        var min = extractWizzyMinFromNode(value);
        if (min != null && min > 0) result[normalized] = min;
    }

    if (Array.isArray(payload)) {
        payload.forEach(function (item) {
            if (!item || typeof item !== 'object') return;
            var sku = extractWizzySkuFromObject(item);
            if (sku) assign(sku, item);
        });
        return result;
    }

    if (!payload || typeof payload !== 'object') return result;

    ['products', 'results', 'items', 'data', 'weights'].forEach(function (listKey) {
        var listOrMap = payload[listKey];
        if (!listOrMap) return;
        if (Array.isArray(listOrMap)) {
            listOrMap.forEach(function (item) {
                if (!item || typeof item !== 'object') return;
                var sku = extractWizzySkuFromObject(item);
                if (sku) assign(sku, item);
            });
        } else if (typeof listOrMap === 'object') {
            Object.keys(listOrMap).forEach(function (key) {
                var normalizedKey = String(key || '').trim();
                if (!normalizedKey) return;
                if (['success', 'status', 'message', 'error', 'errors', 'meta'].indexOf(normalizedKey.toLowerCase()) >= 0) {
                    return;
                }
                if (!Object.keys(requested).length || requested[normalizedKey.toLowerCase()]) {
                    assign(normalizedKey, listOrMap[key]);
                }
            });
            if (Array.isArray(listOrMap.items)) {
                listOrMap.items.forEach(function (item) {
                    if (!item || typeof item !== 'object') return;
                    var sku = extractWizzySkuFromObject(item);
                    if (sku) assign(sku, item);
                });
            }
        }
    });

    // API keyed directly by SKU on the root object
    Object.keys(payload).forEach(function (key) {
        var normalizedKey = String(key || '').trim();
        if (!normalizedKey || !requested[normalizedKey.toLowerCase()]) return;
        assign(normalizedKey, payload[key]);
    });

    return result;
}

/**
 * Wizzy-owned min-weight hydrate - delegated to unified products-batch meta hydrate.
 */
function hydrateWizzyCardMinWeights() {
    hydrateWizzyCardMeta();
}

function fillWizzyWeightsFromBatch(skus, cardsBySku, cfg) {
    var stillLoading = skus.filter(function (sku) {
        return (cardsBySku[sku] || []).some(function (card) {
            return card.getAttribute('data-wizzy-weight-ready') !== 'true';
        });
    });
    if (!stillLoading.length) return;

    fetchWizzyBatchMinWeights(stillLoading, cfg)
        .then(function (map) {
            function lookupGrams(sku) {
                if (map[sku] != null) return map[sku];
                var needle = String(sku).toLowerCase();
                var keys = Object.keys(map);
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i].toLowerCase() === needle) return map[keys[i]];
                }
                return null;
            }

            stillLoading.forEach(function (sku) {
                var grams = lookupGrams(sku);
                if (grams != null) storeWizzyCachedWeight(sku, grams);
                (cardsBySku[sku] || []).forEach(function (card) {
                    if (grams != null) {
                        applyWizzyMinWeightDisplay(card, grams);
                    } else if (card.__wizzyQtyMinWeight != null) {
                        applyWizzyMinWeightDisplay(card, card.__wizzyQtyMinWeight);
                    } else {
                        applyWizzyMinWeightDisplay(card, null);
                    }
                });
            });

            // Re-assert after weight-service may have briefly overwritten DOM
            window.setTimeout(restoreWizzyWeightsFromCache, 100);
            window.setTimeout(restoreWizzyWeightsFromCache, 600);
            window.setTimeout(restoreWizzyWeightsFromCache, 1600);
        })
        .catch(function () {
            stillLoading.forEach(function (sku) {
                (cardsBySku[sku] || []).forEach(function (card) {
                    applyWizzyMinWeightDisplay(card, card.__wizzyQtyMinWeight);
                });
            });
            window.setTimeout(restoreWizzyWeightsFromCache, 100);
        });
}

/**
 * Normalize Shopify product GID / numeric id to digits-only string.
 * @param {unknown} value
 * @returns {string}
 */
function normalizeWizzyProductId(value) {
    if (value == null) return '';
    var stringValue = String(value).trim();
    if (!stringValue) return '';
    if (stringValue.indexOf('/') >= 0) {
        stringValue = stringValue.split('/').pop() || '';
    }
    return String(stringValue).trim();
}

/**
 * True when products-batch has already written this parent product into AOneProductWeights.
 * @param {string} productId
 * @returns {boolean}
 */
function isWizzyProductInWeightStore(productId) {
    var key = normalizeWizzyProductId(productId);
    if (!key) return false;
    var store = window.AOneProductWeights;
    return !!(store && store.products && typeof store.products.has === 'function' && store.products.has(key));
}

/**
 * Remember the merge group of a card from its ?view=qty payload.
 * @param {unknown} productId Card data-product-id
 * @param {Record<string, unknown>|null|undefined} stockMap
 */
function recordWizzyGroupProductIds(productId, stockMap) {
    var key = normalizeWizzyProductId(productId);
    if (!key || !stockMap || typeof stockMap !== 'object') return;
    var ids = [key];
    function addId(value) {
        var id = normalizeWizzyProductId(value);
        if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    addId(stockMap._product_id);
    String(stockMap._linked_product_ids || '')
        .split(',')
        .forEach(addId);
    wizzyGroupProductIdsById[key] = ids;
}

/**
 * Every product id whose WMS weight / cart lines belong to this card.
 * @param {unknown} productId Card data-product-id
 * @returns {string[]}
 */
function getWizzyGroupProductIds(productId) {
    var key = normalizeWizzyProductId(productId);
    if (!key) return [];
    var ids = wizzyGroupProductIdsById[key];
    return ids && ids.length ? ids.slice() : [key];
}

/**
 * @param {string} productId Card data-product-id
 * @returns {boolean}
 */
function isWizzyGroupInWeightStore(productId) {
    var ids = getWizzyGroupProductIds(productId);
    return ids.length > 0 && ids.every(isWizzyProductInWeightStore);
}

/**
 * Keep min-weight on "Checking..." without changing qty / ATC.
 * @param {HTMLElement} card
 */
function setWizzyCardWeightLoading(card) {
    if (!(card instanceof HTMLElement)) return;
    var minWeightValue = card.querySelector('[data-wizzy-min-weight-value], [data-min-weight-value]');
    if (minWeightValue) {
        minWeightValue.textContent = WIZZY_META_LOADING_DISPLAY;
        minWeightValue.setAttribute('data-min-weight-loading', '');
        minWeightValue.setAttribute('data-state', 'loading');
    }
    card.setAttribute('data-min-weight-state', 'loading');
    card.removeAttribute('data-wizzy-weight-ready');
    card.removeAttribute('data-weight-hydrated');
    var row = card.querySelector('.plp-card__min-weight');
    if (row) row.setAttribute('data-min-weight-state', 'loading');
}

/**
 * @param {string} productId
 * @param {{ weight?: number|null, qty?: number|null, storefrontStatus?: string, rawQty?: number|null, loading?: boolean, qtySource?: string }} meta
 */
function storeWizzyCachedMeta(productId, meta) {
    var key = normalizeWizzyProductId(productId);
    if (!key || !meta) return;
    if (meta.loading) return;
    var existing = wizzyMetaCache[key];
    var weightN = Number(meta.weight);
    var qtyN = Number(meta.qty);
    var rawN = Number(meta.rawQty);
    var hasWeight = Number.isFinite(weightN) && weightN > 0;
    // When weight is not ready yet, keep prior weight (if any) — never cache null as final.
    var weight =
        hasWeight
            ? weightN
            : meta.weightReady === false
              ? existing && existing.weight != null
                  ? existing.weight
                  : null
              : null;
    wizzyMetaCache[key] = {
        weight: weight,
        weightReady: meta.weightReady === false ? false : true,
        qty: Number.isFinite(qtyN) && qtyN >= 0 ? Math.floor(qtyN) : null,
        storefrontStatus: meta.storefrontStatus ? String(meta.storefrontStatus) : '',
        rawQty: Number.isFinite(rawN) && rawN >= 0 ? Math.floor(rawN) : null,
        qtySource: meta.qtySource ? String(meta.qtySource) : WIZZY_QTY_SOURCE_SHOPIFY,
    };
    if (meta.weightReady === false) return;
    var sku = '';
    try {
        var card = document.querySelector(
            '.wizzy-search-results-list .plp-card[data-product-id="' +
                key +
                '"], .wizzy-search-results-list .inventory-product-row[data-product-id="' +
                key +
                '"]'
        );
        if (card) sku = readWizzyCardSku(card);
    } catch (e) {
        /* noop */
    }
    if (sku) storeWizzyCachedWeight(sku, wizzyMetaCache[key].weight);
}

/**
 * @param {string} productId
 * @returns {{ weight: number|null, qty: number|null, storefrontStatus?: string, rawQty?: number|null }|undefined}
 */
function lookupWizzyCachedMeta(productId) {
    var key = normalizeWizzyProductId(productId);
    if (!key || !Object.prototype.hasOwnProperty.call(wizzyMetaCache, key)) return undefined;
    return wizzyMetaCache[key];
}

/**
 * Raw Product Batch summary only (not cart-aware). Prefer resolveCartAwareWizzyMeta().
 * @param {string} productId
 * @returns {{ weight: number|null, qty: number|null }|undefined}
 */
function lookupWizzyMetaFromAOneStoreRaw(productId) {
    var key = normalizeWizzyProductId(productId);
    if (!key) return undefined;
    var store = window.AOneProductWeights;
    if (!store || !store.products || typeof store.products.get !== 'function') return undefined;
    if (!store.products.has(key)) return undefined;

    var product = store.products.get(key);
    if (!product || typeof product !== 'object') {
        return { weight: null, qty: 0 };
    }

    return normalizeWizzyMetaFromProduct(product);
}

/**
 * Cart-aware remaining availability for a product card.
 * Source of truth: WMSInventory.getProductAvailability (live WMS − cart serials).
 * @param {string} productId
 * @returns {{ weight: number|null, qty: number|null, storefrontStatus?: string, rawQty?: number|null, loading?: boolean }|undefined}
 */
function resolveCartAwareWizzyMeta(productId) {
    var key = normalizeWizzyProductId(productId);
    if (!key) return undefined;

    var availabilityApi = getWizzyWmsAvailabilityApi();
    if (availabilityApi && typeof availabilityApi.getProductAvailability === 'function') {
        var cartAware = availabilityApi.getProductAvailability(key);
        var cartReady =
            typeof availabilityApi.isCartStateReady !== 'function' ||
            availabilityApi.isCartStateReady();

        // Idle / missing batch → not loaded yet; fall through to raw store / fetch.
        if (cartAware && cartAware.status === 'idle') {
            return lookupWizzyMetaFromAOneStoreRaw(key);
        }

        if (cartAware && cartAware.status === 'loading') {
            return { weight: null, qty: null, loading: true };
        }

        if (cartAware && cartAware.status === 'loaded') {
            // Product is loaded; wait for cart before painting remaining qty/min weight.
            if (!cartReady) {
                return { weight: null, qty: null, loading: true };
            }
            var effectiveQty = Math.max(
                0,
                Math.floor(
                    Number(
                        cartAware.totalAvailableCount != null
                            ? cartAware.totalAvailableCount
                            : cartAware.effectiveAvailableCount
                    ) || 0
                )
            );
            var rawQty = Math.max(
                0,
                Math.floor(Number(cartAware.rawWmsTotalAvailableCount) || 0)
            );
            var minWeightN = Number(cartAware.minWeight);
            return {
                // Min weight is independent of remaining qty — show whenever WMS provides it.
                weight: Number.isFinite(minWeightN) && minWeightN > 0 ? minWeightN : null,
                qty: effectiveQty,
                rawQty: rawQty,
                storefrontStatus: cartAware.storefrontStatus
                    ? String(cartAware.storefrontStatus)
                    : '',
            };
        }
        if (cartAware && cartAware.status === 'error') {
            return { weight: null, qty: 0, rawQty: 0, storefrontStatus: 'COMING_SOON' };
        }
    }

    return lookupWizzyMetaFromAOneStoreRaw(key);
}

/**
 * Cart-aware min weight for a card: lowest weight across its merge group.
 * Single-product cards return resolveCartAwareWizzyMeta unchanged.
 * @param {string} productId Card data-product-id
 * @returns {{ weight: number|null, qty?: number|null, loading?: boolean }|undefined}
 */
function resolveWizzyGroupCartAwareMeta(productId) {
    var groupIds = getWizzyGroupProductIds(productId);
    if (groupIds.length <= 1) return resolveCartAwareWizzyMeta(productId);

    var lowestWeight = null;
    var hasMeta = false;
    for (var i = 0; i < groupIds.length; i++) {
        var meta = resolveCartAwareWizzyMeta(groupIds[i]);
        if (!meta) continue;
        if (meta.loading) return { weight: null, qty: null, loading: true };
        hasMeta = true;
        var weightN = Number(meta.weight);
        if (Number.isFinite(weightN) && weightN > 0 && (lowestWeight === null || weightN < lowestWeight)) {
            lowestWeight = weightN;
        }
    }
    return hasMeta ? { weight: lowestWeight } : undefined;
}

/**
 * Read weight + qty from weight-service products-batch store.
 * Prefers cart-aware WMSInventory values whenever product batch has been upserted.
 * @param {string} productId
 * @returns {{ weight: number|null, qty: number|null, storefrontStatus?: string, rawQty?: number|null, loading?: boolean }|undefined}
 */
function lookupWizzyMetaFromAOneStore(productId) {
    return resolveCartAwareWizzyMeta(productId);
}

/**
 * Normalize a Product Batch product node into Wizzy card meta.
 * Min weight and qty are independent — weight comes from API even when qty is 0.
 * @param {Record<string, unknown>|null|undefined} product
 * @returns {{ weight: number|null, qty: number }}
 */
function normalizeWizzyMetaFromProduct(product) {
    if (!product || typeof product !== 'object') {
        return { weight: null, qty: 0 };
    }

    var summary =
        product.summary && typeof product.summary === 'object' ? product.summary : {};
    var minWeightOption =
        summary.minimumWeightOption && typeof summary.minimumWeightOption === 'object'
            ? summary.minimumWeightOption
            : null;

    var qtyRaw =
        summary.totalAvailableQuantity != null
            ? summary.totalAvailableQuantity
            : summary.totalAvailableCount != null
              ? summary.totalAvailableCount
              : summary.availableCount != null
                ? summary.availableCount
                : summary.availableQuantity != null
                  ? summary.availableQuantity
                  : product.totalAvailableQuantity != null
                    ? product.totalAvailableQuantity
                    : 0;
    var qtyN = Number(qtyRaw);
    var qty = Number.isFinite(qtyN) && qtyN >= 0 ? Math.floor(qtyN) : 0;

    var weightRaw =
        summary.overallMinWeight != null
            ? summary.overallMinWeight
            : summary.minWeight != null
              ? summary.minWeight
              : minWeightOption && minWeightOption.weight != null
                ? minWeightOption.weight
                : summary.min_weight != null
                  ? summary.min_weight
                  : product.overallMinWeight != null
                    ? product.overallMinWeight
                    : null;
    var weightN = Number(weightRaw);

    return {
        weight: Number.isFinite(weightN) && weightN > 0 ? weightN : null,
        qty: qty,
    };
}

/**
 * Same final states as collection weight-service:
 * loading | available | coming-soon | all-in-cart (never Availability unavailable).
 * @param {{ weight?: number|null, qty?: number|null, storefrontStatus?: string, rawQty?: number|null, loading?: boolean }|null|undefined} meta
 * @param {{ forceLoading?: boolean }} [options]
 * @returns {{
 *   status: 'loading'|'available'|'coming-soon'|'all-in-cart',
 *   totalAvailableQuantity: number,
 *   minimumWeight: number|null,
 *   buttonText: string,
 *   disabled: boolean
 * }}
 */
function normalizeWizzyWmsAvailability(meta, options) {
    var opts = options || {};
    if (opts.forceLoading || (meta && meta.loading)) {
        return {
            status: 'loading',
            totalAvailableQuantity: 0,
            minimumWeight: null,
            buttonText: WIZZY_BUTTON_LOADING_DISPLAY,
            disabled: true,
        };
    }

    var qtyN = Number(meta && meta.qty);
    var quantity = Number.isFinite(qtyN) && qtyN > 0 ? Math.floor(qtyN) : 0;
    var weightN = Number(meta && meta.weight);
    var minimumWeight = Number.isFinite(weightN) && weightN > 0 ? weightN : null;
    var rawQtyN = Number(meta && meta.rawQty);
    var rawQty = Number.isFinite(rawQtyN) && rawQtyN >= 0 ? Math.floor(rawQtyN) : null;
    var storefrontStatus = String((meta && meta.storefrontStatus) || '')
        .trim()
        .toUpperCase();
    var availabilityApi = getWizzyWmsAvailabilityApi();
    var allInCartLabel =
        (availabilityApi && availabilityApi.LABEL_ALL_IN_CART) || WIZZY_BUTTON_ALL_IN_CART;

    if (quantity > 0 && storefrontStatus !== 'ALL_IN_CART' && storefrontStatus !== 'COMING_SOON') {
        return {
            status: 'available',
            totalAvailableQuantity: quantity,
            minimumWeight: minimumWeight,
            buttonText: WIZZY_BUTTON_ADD_TO_CART,
            disabled: false,
        };
    }

    if (
        storefrontStatus === 'ALL_IN_CART' ||
        (rawQty != null && rawQty > 0 && quantity <= 0)
    ) {
        return {
            status: 'all-in-cart',
            totalAvailableQuantity: 0,
            minimumWeight: minimumWeight,
            buttonText: allInCartLabel,
            disabled: false,
        };
    }

    return {
        status: 'coming-soon',
        totalAvailableQuantity: 0,
        minimumWeight: minimumWeight,
        buttonText: WIZZY_BUTTON_COMING_SOON,
        disabled: true,
    };
}

/**
 * @param {HTMLElement} action
 * @param {string} label
 */
function setWizzyActionLabel(action, label) {
    var labelHosts = action.querySelectorAll(
        '.add-to-cart-text__content span span, .quick-add__button-text span span'
    );
    if (labelHosts.length) {
        labelHosts.forEach(function (labelHost) {
            if (labelHost instanceof HTMLElement) labelHost.textContent = label;
        });
        return;
    }
    var fallback = action.querySelector('.add-to-cart-text__content, .quick-add__button-text');
    if (fallback instanceof HTMLElement) {
        var nested = fallback.querySelector('span span') || fallback.querySelector('span');
        if (nested instanceof HTMLElement) nested.textContent = label;
    }
}

/**
 * @param {HTMLElement} action
 * @param {boolean} shouldDisable
 */
function setWizzyActionDisabled(action, shouldDisable) {
    if (!(action instanceof HTMLButtonElement)) return;
    action.disabled = shouldDisable;
    action.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
    action.classList.toggle('plp-card__atc--disabled', shouldDisable);
    action.classList.toggle('plp-card__atc--active', !shouldDisable);
}

/**
 * Apply ATC / Coming soon / loading on the current Wizzy card only.
 * @param {HTMLElement} card
 * @param {ReturnType<typeof normalizeWizzyWmsAvailability>} state
 */
function applyWizzyAvailabilityButton(card, state) {
    if (!(card instanceof HTMLElement) || !state) return;

    card.setAttribute('data-wms-status', state.status);
    card.setAttribute(
        'data-wms-inventory-status',
        state.status === 'coming-soon'
            ? 'coming_soon'
            : state.status === 'all-in-cart'
              ? 'all_in_cart'
              : state.status
    );
    card.setAttribute('data-wms-loading', state.status === 'loading' ? 'true' : 'false');
    card.setAttribute('data-wms-available-qty', String(state.totalAvailableQuantity));
    if (state.minimumWeight != null) {
        card.setAttribute('data-wms-min-weight', String(state.minimumWeight));
    } else {
        card.removeAttribute('data-wms-min-weight');
    }

    var availabilityApi = getWizzyWmsAvailabilityApi();
    var actionNodes = card.querySelectorAll('[data-product-action], .plp-card__atc');
    actionNodes.forEach(function (actionNode) {
        if (!(actionNode instanceof HTMLElement)) return;
        actionNode.setAttribute('aria-busy', state.status === 'loading' ? 'true' : 'false');
        actionNode.setAttribute('data-wms-state', state.status);
        actionNode.setAttribute('data-wms-status', state.status);

        if (availabilityApi && typeof availabilityApi.applyButtonState === 'function') {
            var buttonState =
                state.status === 'available'
                    ? 'available'
                    : state.status === 'all-in-cart'
                      ? 'all-in-cart'
                      : state.status;
            availabilityApi.applyButtonState(actionNode, buttonState, {
                label: state.buttonText,
                disabled: state.disabled,
            });
            return;
        }

        setWizzyActionLabel(actionNode, state.buttonText);
        setWizzyActionDisabled(actionNode, state.disabled);
    });

    var shouldShowComingSoon = state.status === 'coming-soon';
    var media = card.querySelector('.plp-card__media');
    if (media instanceof HTMLElement) {
        var badge = media.querySelector('[data-product-sold-out-badge], .plp-card__badge--soldout');
        if (shouldShowComingSoon) {
            if (!badge) {
                badge = document.createElement('span');
                badge.className = 'plp-card__badge plp-card__badge--soldout';
                badge.setAttribute('data-product-sold-out-badge', '');
                media.insertBefore(badge, media.firstChild);
            }
            badge.hidden = false;
            badge.textContent = WIZZY_BUTTON_COMING_SOON;
        } else if (badge) {
            badge.hidden = true;
        }
    }

    var item = card.closest('.plp-product-grid__item, .wizzy-result-product');
    if (item) {
        var listBadgeText =
            item.querySelector('[data-wms-status-badge] .plp-list-card__badge-text') ||
            item.querySelector('[data-wms-status-badge]');
        if (listBadgeText instanceof HTMLElement) {
            if (state.status === 'loading') listBadgeText.textContent = WIZZY_BUTTON_LOADING_DISPLAY;
            else if (state.status === 'coming-soon') listBadgeText.textContent = WIZZY_BUTTON_COMING_SOON;
            else if (state.status === 'all-in-cart') listBadgeText.textContent = 'AVAILABLE QTY: 0';
            else listBadgeText.textContent = 'AVAILABLE';
        }
    }
}

/** Show loaders for weight + qty + ATC while products-batch is in flight. */
function setWizzyCardMetaLoading(card, options) {
    if (!(card instanceof HTMLElement)) return;
    var opts = options || {};

    var minWeightValue = card.querySelector('[data-wizzy-min-weight-value], [data-min-weight-value]');
    if (minWeightValue) {
        minWeightValue.textContent = WIZZY_META_LOADING_DISPLAY;
        minWeightValue.setAttribute('data-min-weight-loading', '');
        minWeightValue.setAttribute('data-state', 'loading');
    }
    card.setAttribute('data-min-weight-state', 'loading');
    card.removeAttribute('data-wizzy-weight-ready');
    card.removeAttribute('data-wizzy-qty-ready');
    card.removeAttribute('data-weight-hydrated');

    var row = card.querySelector('.plp-card__min-weight');
    if (row) row.setAttribute('data-min-weight-state', 'loading');

    var qtyRow = card.querySelector('[data-wizzy-available-qty]');
    var qtyValue = card.querySelector('[data-wizzy-available-qty-value], [data-available-qty-value]');
    if (qtyRow) {
        qtyRow.removeAttribute('hidden');
        qtyRow.setAttribute('data-qty-state', 'loading');
    }
    if (qtyValue) {
        qtyValue.textContent = WIZZY_META_LOADING_DISPLAY;
        qtyValue.setAttribute('data-state', 'loading');
    }

    applyWizzyAvailabilityButton(card, normalizeWizzyWmsAvailability(null, { forceLoading: true }));
    // Keep cart-derived Order Sheet fields live even while WMS meta is loading,
    // but do not wipe them to 0 while cart itself is unresolved.
    if (opts.preserveInCartSummary !== true) {
        applyWizzyInCartSummaryDisplay(card);
    }
}

/**
 * Show Available Qty beside min weight.
 * Zero quantity stays visible as 0 (Coming soon path).
 * @param {HTMLElement} card
 * @param {number|null|undefined} qty
 */
function applyWizzyAvailableQtyDisplay(card, qty) {
    if (!(card instanceof HTMLElement)) return;
    var row = card.querySelector('[data-wizzy-available-qty]');
    var valueEl = card.querySelector('[data-wizzy-available-qty-value], [data-available-qty-value]');
    if (!valueEl) return;

    var n = Number(qty);
    var safeQty = Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0;

    valueEl.textContent = String(safeQty);
    valueEl.setAttribute('data-state', 'ready');
    if (row) {
        row.removeAttribute('hidden');
        row.setAttribute('data-qty-state', 'ready');
    }
    card.setAttribute('data-wizzy-qty-ready', 'true');
}

/**
 * @param {number} grams
 * @returns {string}
 */
function formatWizzyCartWeightDisplay(grams) {
    var value = Number(grams);
    if (!Number.isFinite(value) || value <= 0) return '0.000 g';
    return (Math.round((value + Number.EPSILON) * 1000) / 1000).toFixed(3) + ' g';
}

/**
 * Paint Grid + Order Sheet In Cart Qty / Cart Weight from shared WMS cart summary.
 * @param {HTMLElement} card
 * @param {Record<string, { quantity: number, totalWeight: number }>|null|undefined} [summaryByProduct]
 */
function applyWizzyInCartSummaryDisplay(card, summaryByProduct) {
    if (!(card instanceof HTMLElement)) return;
    var qtyEl = card.querySelector('[data-wizzy-in-cart-qty-value], [data-in-cart-qty-value]');
    var weightEl = card.querySelector('[data-wizzy-cart-weight-value], [data-cart-weight-value]');
    if (!qtyEl && !weightEl) return;

    var productId = normalizeWizzyProductId(card.getAttribute('data-product-id'));
    var quantity = 0;
    var totalWeight = 0;
    var availabilityApi = getWizzyWmsAvailabilityApi();

    // Merged cards: cart lines of every product in the group count toward this card.
    getWizzyGroupProductIds(productId).forEach(function (groupProductId) {
        if (summaryByProduct) {
            var mapped = summaryByProduct[groupProductId];
            quantity += Math.max(0, Math.floor(Number(mapped && mapped.quantity) || 0));
            totalWeight += Math.max(0, Number(mapped && mapped.totalWeight) || 0);
        } else if (availabilityApi && typeof availabilityApi.getProductCartSummary === 'function') {
            var summary = availabilityApi.getProductCartSummary(groupProductId);
            quantity += Math.max(0, Math.floor(Number(summary && summary.quantity) || 0));
            totalWeight += Math.max(0, Number(summary && summary.totalWeight) || 0);
        }
    });

    if (qtyEl) qtyEl.textContent = String(quantity);
    if (weightEl) weightEl.textContent = formatWizzyCartWeightDisplay(totalWeight);
}

/**
 * Apply weight + qty + ATC.
 * If meta.weightReady === false, qty/ATC update and weight stays "Checking...".
 * @param {HTMLElement} card
 * @param {{ weight: number|null, qty: number|null, storefrontStatus?: string, rawQty?: number|null, loading?: boolean, weightReady?: boolean }} meta
 * @param {Record<string, { quantity: number, totalWeight: number }>|null|undefined} [summaryByProduct]
 */
function applyWizzyCardMeta(card, meta, summaryByProduct) {
    if (!(card instanceof HTMLElement) || !meta) return;

    var state = normalizeWizzyWmsAvailability(meta);
    var weightN = Number(meta.weight != null ? meta.weight : state.minimumWeight);
    var weightForDisplay = Number.isFinite(weightN) && weightN > 0 ? weightN : null;
    var qtyForDisplay = state.totalAvailableQuantity;
    var weightReady = meta.weightReady !== false;

    wizzyMetaApplyingCartAware = true;
    try {
        if (!weightReady && weightForDisplay == null) {
            setWizzyCardWeightLoading(card);
        } else {
            applyWizzyMinWeightDisplay(card, weightForDisplay);
        }
        applyWizzyAvailableQtyDisplay(card, qtyForDisplay);
        applyWizzyInCartSummaryDisplay(card, summaryByProduct);
        applyWizzyAvailabilityButton(card, state);

        if (state.status !== 'loading' && weightReady) {
            card.setAttribute('data-weight-hydrated', 'true');
            card.setAttribute('data-min-weight-state', 'ready');
        }
    } finally {
        window.setTimeout(function () {
            wizzyMetaApplyingCartAware = false;
        }, 0);
    }
}

/**
 * Re-paint Grid + Order Sheet Wizzy cards after cart changes.
 * Available Qty + Coming Soon stay on Shopify inventory; only weight / in-cart summary refresh from WMS cart.
 * @param {{ generation?: number, loading?: boolean, cartReady?: boolean }|null} [detail]
 */
function reapplyWizzyCartAwareCardDisplays(detail) {
    ensureWizzyMetaCartInventoryBinding();
    var eventGeneration = Number(detail && detail.mutationGeneration);
    if (Number.isFinite(eventGeneration) && eventGeneration > 0) {
        if (eventGeneration < wizzyMetaCartGeneration) return;
        wizzyMetaCartGeneration = eventGeneration;
    } else {
        wizzyMetaCartGeneration += 1;
    }
    var paintGeneration = wizzyMetaCartGeneration;

    var availabilityApi = getWizzyWmsAvailabilityApi();
    var summaryByProduct =
        availabilityApi && typeof availabilityApi.buildCartSummaryByProduct === 'function'
            ? availabilityApi.buildCartSummaryByProduct(detail && detail.cart)
            : null;

    var cards = document.querySelectorAll(WIZZY_META_CARD_SELECTOR);

    // Cart sync in flight — keep Shopify qty / Coming Soon; only refresh in-cart rows.
    if (detail && (detail.loading === true || detail.cartReady === false)) {
        cards.forEach(function (card) {
            if (!(card instanceof HTMLElement)) return;
            applyWizzyInCartSummaryDisplay(card, summaryByProduct);
        });
        return;
    }

    cards.forEach(function (card) {
        if (paintGeneration !== wizzyMetaCartGeneration) return;
        if (!(card instanceof HTMLElement)) return;
        var productId = normalizeWizzyProductId(card.getAttribute('data-product-id'));
        if (!productId) return;

        var cached = lookupWizzyCachedMeta(productId);
        var shopifyQty =
            cached && cached.qty != null && Number.isFinite(Number(cached.qty))
                ? Math.max(0, Math.floor(Number(cached.qty)))
                : null;

        if (shopifyQty == null) {
            applyWizzyInCartSummaryDisplay(card, summaryByProduct);
            return;
        }

        var wmsMeta = resolveWizzyGroupCartAwareMeta(productId);
        var weightMeta =
            wmsMeta && !wmsMeta.loading
                ? wmsMeta
                : cached
                  ? { weight: cached.weight }
                  : { weight: null };
        var meta = mergeWizzyMetaWithShopifyQty(weightMeta, shopifyQty);
        // Weight stays Checking... until products-batch for this productId.
        if (
            (wmsMeta && wmsMeta.loading) ||
            (meta.weight == null &&
                cached &&
                cached.weightReady === false &&
                !isWizzyGroupInWeightStore(productId))
        ) {
            meta.weightReady = false;
        }
        storeWizzyCachedMeta(productId, meta);
        applyWizzyCardMeta(card, meta, summaryByProduct);
    });
}

/** Re-paint weight + qty + ATC after weight-service / BFCache DOM resets. */
function restoreWizzyMetaFromCache() {
    if (wizzyMetaApplyingCartAware) return;

    var cards = document.querySelectorAll(WIZZY_META_CARD_SELECTOR);
    cards.forEach(function (card) {
        if (!(card instanceof HTMLElement)) return;
        var productId = normalizeWizzyProductId(card.getAttribute('data-product-id'));
        if (!productId) return;

        // Prefer cached Shopify qty; refresh weight from WMS when available.
        var cached = lookupWizzyCachedMeta(productId);
        if (cached === undefined || cached.qty == null) return;

        var wmsMeta = resolveWizzyGroupCartAwareMeta(productId);
        var weightMeta =
            wmsMeta && !wmsMeta.loading
                ? wmsMeta
                : { weight: cached.weight };
        var meta = mergeWizzyMetaWithShopifyQty(weightMeta, cached.qty);
        if (
            (wmsMeta && wmsMeta.loading) ||
            (meta.weight == null &&
                cached.weightReady === false &&
                !isWizzyGroupInWeightStore(productId))
        ) {
            meta.weightReady = false;
        }
        storeWizzyCachedMeta(productId, meta);

        var state = normalizeWizzyWmsAvailability(meta);
        var stillLoading =
            meta.weightReady === false ||
            card.getAttribute('data-min-weight-state') === 'loading' ||
            card.getAttribute('data-wms-status') === 'loading' ||
            !card.getAttribute('data-weight-hydrated');

        var action = card.querySelector('[data-product-action], .plp-card__atc');
        var actionText = action
            ? String(
                  (
                      action.querySelector('.add-to-cart-text__content span span, .quick-add__button-text span span') ||
                      action
                  ).textContent || ''
              ).trim()
            : '';
        var expectedButton = state.buttonText;
        var buttonOk = actionText === expectedButton;

        var qtyValue = card.querySelector('[data-wizzy-available-qty-value], [data-available-qty-value]');
        var qtyText = qtyValue ? String(qtyValue.textContent || '').trim() : '';
        var qtyOk = qtyText === String(state.totalAvailableQuantity);

        var minWeightValue = card.querySelector('[data-wizzy-min-weight-value], [data-min-weight-value]');
        var weightText = minWeightValue ? String(minWeightValue.textContent || '').trim() : '';
        var expectedWeight =
            state.minimumWeight != null
                ? (Math.round(Number(state.minimumWeight) * 1000) / 1000).toFixed(3) + ' g'
                : WIZZY_META_EMPTY_DISPLAY;
        // Also accept weight-service compact format (e.g. 8.8g) as already correct.
        var compactWeight =
            state.minimumWeight != null
                ? String(state.minimumWeight)
                      .replace(/\.0+$/, '')
                      .replace(/(\.\d*?)0+$/, '$1') + 'g'
                : WIZZY_META_EMPTY_DISPLAY;
        var weightOk =
            weightText === expectedWeight ||
            weightText === compactWeight ||
            weightText.replace(/\s+/g, '') === compactWeight;

        if (
            !stillLoading &&
            buttonOk &&
            qtyOk &&
            weightOk &&
            card.getAttribute('data-wms-status') === state.status
        ) {
            return;
        }
        applyWizzyCardMeta(card, meta);
    });
}

function ensureWizzyMetaRestoreObserver() {
    if (wizzyMetaRestoreObserver) return;
    var root = document.body;
    if (!root) return;

    wizzyMetaRestoreObserver = new MutationObserver(function (mutations) {
        if (wizzyMetaApplyingCartAware) return;
        var shouldSync = false;
        for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (!m || !m.target || !(m.target instanceof Element)) continue;
            if (
                m.attributeName === 'data-weight-hydrated' ||
                m.attributeName === 'data-min-weight-state' ||
                m.attributeName === 'data-product-id'
            ) {
                if (
                    m.target.matches &&
                    (m.target.matches(
                        '.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .wizzy-result-product .plp-card, .wizzy-autocomplete-wrapper .plp-card'
                    ) ||
                        m.target.closest(
                            '.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .wizzy-autocomplete-wrapper .plp-card'
                        ))
                ) {
                    shouldSync = true;
                    break;
                }
            }
        }
        if (!shouldSync) return;

        window.clearTimeout(wizzyMetaRestoreTimer);
        wizzyMetaRestoreTimer = window.setTimeout(function () {
            wizzyMetaRestoreTimer = null;
            // Restore only - do not re-schedule fetch here (avoids attribute write loops).
            restoreWizzyMetaFromCache();
        }, 120);
    });
    wizzyMetaRestoreObserver.observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-min-weight-state', 'data-weight-hydrated', 'data-product-id'],
    });
}

function ensureWizzyMetaCartInventoryBinding() {
    if (wizzyMetaCartInventoryBound) return;
    wizzyMetaCartInventoryBound = true;
    var availabilityApi = getWizzyWmsAvailabilityApi();
    var eventName =
        (availabilityApi && availabilityApi.CART_INVENTORY_EVENT) || 'aone:cart-inventory-updated';
    document.addEventListener(eventName, function (event) {
        var detail = event && event.detail ? event.detail : null;
        reapplyWizzyCartAwareCardDisplays(detail);
    });
}

function ensureWizzyMetaPageshowBinding() {
    // window flag, not only the var: a later throw or a second script pass can
    // reset wizzyMetaPageshowBound without removing a listener that was never added.
    if (window.__aoneWizzyMetaPageshowBound || wizzyMetaPageshowBound) {
        wizzyMetaPageshowBound = true;
        window.__aoneWizzyMetaPageshowBound = true;
        return;
    }
    wizzyMetaPageshowBound = true;
    window.__aoneWizzyMetaPageshowBound = true;
    ensureWizzyMetaCartInventoryBinding();
    window.addEventListener('pageshow', function () {
        // BFCache restore does not re-run this file or Wizzy VIEW_RENDERED.
        // The cards are already in the DOM; the same hydrate path paints them.
        scheduleHydrateWizzyCardMeta(50);
    });
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            scheduleHydrateWizzyCardMeta(80);
        }
    });
}

// Install before autocomplete / view-switcher startup. Those blocks run at
// file scope and a throw there used to skip this call, so Back left cards on Checking...
ensureWizzyMetaPageshowBinding();
scheduleHydrateWizzyCardMeta(300);

/**
 * POST {base}/public/products/weights/products-batch — one parent product per request.
 * Used only when AOneProductWeightsAPI is absent; otherwise weight-service owns the network.
 * Returns weight (overallMinWeight) + qty (totalAvailableQuantity) per productId.
 */
function fetchWizzyProductsBatchMeta(productIds, cfg) {
    var base = String(cfg.apiBaseUrl || '').replace(/\/+$/, '');
    var url = base + '/public/products/weights/products-batch';
    var headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    try {
        if (new URL(url, window.location.origin).hostname.toLowerCase().indexOf('ngrok') >= 0) {
            headers['ngrok-skip-browser-warning'] = 'true';
        }
    } catch (e) {
        /* noop */
    }

    var uniqueProductIds = [];
    (productIds || []).forEach(function (id) {
        var key = normalizeWizzyProductId(id);
        if (key && uniqueProductIds.indexOf(key) === -1) uniqueProductIds.push(key);
    });
    productIds = uniqueProductIds;

    var requestKey = productIds.slice().sort().join(',');

    if (wizzyMetaInFlightPromise && wizzyMetaInFlightKey === requestKey) {
        return wizzyMetaInFlightPromise;
    }

    if (window.AOneWmsConfig && window.AOneWmsConfig.debug) {
        console.debug('[Inventory Batch]', {
            source: 'wizzy-fallback',
            requestedProductIds: productIds,
            uniqueProductIds: productIds,
            alreadyInFlight: Object.keys(wizzyMetaInFlightByProductId),
            newIdsToFetch: productIds.filter(function (id) {
                return !wizzyMetaInFlightByProductId[id];
            }),
            mode: 'per-parent',
            concurrency: WIZZY_MAX_CONCURRENT_PRODUCT_REQUESTS,
        });
    }

    var timeoutMs = Math.max(
        WIZZY_WMS_REQUEST_TIMEOUT_MS,
        Number(cfg.timeoutMs) || WIZZY_WMS_REQUEST_TIMEOUT_MS
    );

    function fetchOneParent(productId) {
        if (wizzyMetaInFlightByProductId[productId]) {
            return wizzyMetaInFlightByProductId[productId];
        }

        function once() {
            var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
            var timeoutId = window.setTimeout(function () {
                if (controller) controller.abort();
            }, timeoutMs);

            return fetch(url, {
                method: 'POST',
                mode: 'cors',
                credentials: 'omit',
                headers: headers,
                body: JSON.stringify({ productIds: [productId] }),
                signal: controller ? controller.signal : undefined,
            })
                .then(function (res) {
                    if (!res.ok) throw new Error('Products-batch API HTTP ' + res.status);
                    return res.json();
                })
                .then(function (payload) {
                    return parseWizzyProductsBatchMetaMap(payload, [productId]);
                })
                .finally(function () {
                    window.clearTimeout(timeoutId);
                });
        }

        var promise = once()
            .catch(function () {
                return once();
            })
            .catch(function () {
                var fallback = {};
                fallback[productId] = { weight: null, qty: 0 };
                return fallback;
            })
            .finally(function () {
                if (wizzyMetaInFlightByProductId[productId] === promise) {
                    delete wizzyMetaInFlightByProductId[productId];
                }
            });

        wizzyMetaInFlightByProductId[productId] = promise;
        return promise;
    }

    function runWithConcurrency(ids, limit) {
        var merged = {};
        var cursor = 0;
        var active = 0;

        return new Promise(function (resolve) {
            function finishOne(map) {
                if (map && typeof map === 'object') {
                    Object.keys(map).forEach(function (key) {
                        merged[key] = map[key];
                    });
                }
                active -= 1;
                pump();
            }

            function pump() {
                if (cursor >= ids.length && active === 0) {
                    resolve(merged);
                    return;
                }
                while (active < limit && cursor < ids.length) {
                    (function (productId) {
                        active += 1;
                        fetchOneParent(productId)
                            .then(finishOne)
                            .catch(function () {
                                var fallback = {};
                                fallback[productId] = { weight: null, qty: 0 };
                                finishOne(fallback);
                            });
                    })(ids[cursor]);
                    cursor += 1;
                }
            }

            pump();
        });
    }

    wizzyMetaInFlightKey = requestKey;
    wizzyMetaInFlightPromise = runWithConcurrency(
        productIds,
        WIZZY_MAX_CONCURRENT_PRODUCT_REQUESTS
    )
        .then(function (merged) {
            productIds.forEach(function (id) {
                if (!Object.prototype.hasOwnProperty.call(merged, id)) {
                    merged[id] = { weight: null, qty: 0 };
                }
            });
            return merged;
        })
        .finally(function () {
            if (wizzyMetaInFlightKey === requestKey) {
                wizzyMetaInFlightKey = '';
                wizzyMetaInFlightPromise = null;
            }
        });

    return wizzyMetaInFlightPromise;
}

/**
 * @param {unknown} payload
 * @param {string[]} requestedIds
 * @returns {Record<string, { weight: number|null, qty: number|null }>}
 */
function parseWizzyProductsBatchMetaMap(payload, requestedIds) {
    var result = {};
    var requested = {};
    (requestedIds || []).forEach(function (id) {
        var key = normalizeWizzyProductId(id);
        if (key) requested[key] = true;
    });

    function assign(productId, weight, qty) {
        var key = normalizeWizzyProductId(productId);
        if (!key) return;
        if (Object.keys(requested).length && !requested[key]) return;
        var qtyN = Number(qty);
        var safeQty = Number.isFinite(qtyN) && qtyN >= 0 ? Math.floor(qtyN) : 0;
        var weightN = Number(weight);
        result[key] = {
            // Qty drives availability; weight only meaningful when qty > 0.
            weight: safeQty > 0 && Number.isFinite(weightN) && weightN > 0 ? weightN : null,
            qty: safeQty,
        };
    }

    var products = null;
    if (payload && typeof payload === 'object') {
        if (payload.data && Array.isArray(payload.data.products)) {
            products = payload.data.products;
        } else if (Array.isArray(payload.products)) {
            products = payload.products;
        } else if (Array.isArray(payload.data)) {
            products = payload.data;
        } else if (Array.isArray(payload)) {
            products = payload;
        }
    }

    if (!products) {
        Object.keys(requested).forEach(function (key) {
            result[key] = { weight: null, qty: 0 };
        });
        return result;
    }

    products.forEach(function (product) {
        if (!product || typeof product !== 'object') return;
        var normalized = normalizeWizzyMetaFromProduct(product);
        var productId = product.productId != null ? product.productId : product.id;
        assign(productId, normalized.weight, normalized.qty);
    });

    // Every requested product must resolve — never leave loading.
    Object.keys(requested).forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(result, key)) {
            result[key] = { weight: null, qty: 0 };
        }
    });

    return result;
}

/**
 * Unified Wizzy card meta hydrate:
 * - Available Qty + Coming Soon ← Shopify inventory (?view=qty)
 * - Min weight ← WMS products-batch when available (Shopify weight as interim)
 */
function hydrateWizzyCardMeta() {
    ensureWizzyMetaRestoreObserver();
    ensureWizzyMetaPageshowBinding();
    ensureWizzyMetaCartInventoryBinding();
    syncWizzyProductHandlesInDom();

    var cards = Array.prototype.slice.call(document.querySelectorAll(WIZZY_META_CARD_SELECTOR));
    if (!cards.length) return;

    var cfg = getWizzyWeightApiConfig();
    var productIds = [];
    var cardsById = {};
    var generation = ++wizzyMetaRequestGeneration;

    cards.forEach(function (card) {
        var productId = normalizeWizzyProductId(card.getAttribute('data-product-id'));
        if (!productId) {
            applyWizzyCardMeta(
                card,
                mergeWizzyMetaWithShopifyQty({ weight: null }, 0)
            );
            return;
        }

        if (productIds.indexOf(productId) === -1) productIds.push(productId);
        if (!cardsById[productId]) cardsById[productId] = [];
        cardsById[productId].push(card);

        // Fast paint from cache; keep Checking... on weight until products-batch.
        var cached = lookupWizzyCachedMeta(productId);
        if (cached !== undefined && cached.qty != null) {
            var cachedMeta = mergeWizzyMetaWithShopifyQty(cached, cached.qty);
            if (cached.weightReady === false && cachedMeta.weight == null) {
                cachedMeta.weightReady = false;
            }
            applyWizzyCardMeta(card, cachedMeta);
        } else {
            setWizzyCardMetaLoading(card);
        }
    });

    if (!productIds.length) return;

    /**
     * @param {string} productId
     * @param {number} shopifyQty
     * @param {{ weight?: number|null, qty?: number|null, loading?: boolean }|null|undefined} weightMeta
     * @param {boolean} weightReady
     */
    function paintProduct(productId, shopifyQty, weightMeta, weightReady) {
        // Generation guard prevents an older response from overwriting a newer paint.
        // A newer hydrate is always scheduled by the observer/pageshow when Wizzy
        // replaces DOM, so this cannot leave cards permanently on Checking...
        if (generation !== wizzyMetaRequestGeneration) return;

        var meta = mergeWizzyMetaWithShopifyQty(weightMeta || { weight: null }, shopifyQty);
        var hasWeight = meta.weight != null && Number(meta.weight) > 0;
        var ready =
            weightReady === true ||
            hasWeight ||
            isWizzyGroupInWeightStore(productId) ||
            !cfg ||
            !cfg.apiBaseUrl;
        if (!ready) meta.weightReady = false;
        storeWizzyCachedMeta(productId, meta);

        // Always query live DOM at paint time. Wizzy can replace the card
        // between hydrate start and async completion (PDP → Back race).
        // cardsById was captured before the await and may point at detached nodes
        // OR at nodes that are still connected but have since been superseded.
        var currentCards = getCurrentWizzyCardsForProduct(productId);
        currentCards.forEach(function (card) {
            applyWizzyCardMeta(card, meta);
        });
    }

    function resolveWeightMeta(productId) {
        var cartAware = resolveWizzyGroupCartAwareMeta(productId);
        if (cartAware && !cartAware.loading) return cartAware;
        if (cartAware && cartAware.loading) return { weight: null, loading: true };
        var raw = lookupWizzyMetaFromAOneStoreRaw(productId);
        if (raw) return raw;
        var cached = lookupWizzyCachedMeta(productId);
        if (cached && cached.weight != null) return { weight: cached.weight };
        return { weight: null };
    }

    // Shopify qty is required for Available Qty + Coming Soon.
    var shopifyPromises = productIds.map(function (productId) {
        var cardList = cardsById[productId] || [];
        var card = cardList[0];
        if (!(card instanceof HTMLElement) || !card.isConnected) {
            var liveCards = getCurrentWizzyCardsForProduct(productId);
            card = liveCards[0] || card;
        }
        if (!(card instanceof HTMLElement)) {
            return Promise.resolve({ productId: productId, qty: 0 });
        }
        return fetchShopifyQtyForWizzyCard(card).then(function (qty) {
            return { productId: productId, qty: qty };
        });
    });

    Promise.all(shopifyPromises).then(function (shopifyRows) {
        if (generation !== wizzyMetaRequestGeneration) return;

        var shopifyQtyById = {};
        shopifyRows.forEach(function (row) {
            shopifyQtyById[row.productId] = row.qty;
        });

        // Qty first; weight stays Checking... until THAT product's WMS response lands.
        productIds.forEach(function (productId) {
            paintProduct(productId, shopifyQtyById[productId] || 0, resolveWeightMeta(productId), false);
        });

        function paintWeightReady(productId) {
            if (generation !== wizzyMetaRequestGeneration) return;
            paintProduct(
                productId,
                shopifyQtyById[productId] || 0,
                resolveWeightMeta(productId),
                true
            );
        }

        if (!cfg || !cfg.apiBaseUrl) {
            productIds.forEach(paintWeightReady);
            return;
        }

        var weightApi = window.AOneProductWeightsAPI || window.AoneBatchWeight;
        if (weightApi && typeof weightApi.loadCurrentProductWeights === 'function') {
            // One POST per productId (weight-service concurrency queue). Paint each card
            // as soon as its parent (and merged group members) resolve — do not wait for the whole page.
            productIds.forEach(function (productId) {
                Promise.resolve(
                    weightApi.loadCurrentProductWeights(getWizzyGroupProductIds(productId), {
                        source: 'wizzy-render',
                        preferCache: true,
                    })
                )
                    .then(function () {
                        paintWeightReady(productId);
                    })
                    .catch(function (error) {
                        if (error) console.error('[Wizzy] WMS weight failed for', productId, error);
                        paintWeightReady(productId);
                    });
            });
            return;
        }

        // Fallback: same per-parent progressive paint when weight-service is absent.
        productIds.forEach(function (productId) {
            fetchWizzyProductsBatchMeta(getWizzyGroupProductIds(productId), cfg)
                .then(function () {
                    paintWeightReady(productId);
                })
                .catch(function (error) {
                    if (error) console.error('[Wizzy] WMS weight fallback failed for', productId, error);
                    paintWeightReady(productId);
                });
        });
    });
}

function hydrateWizzyCardAvailableQty() {
    hydrateWizzyCardMeta();
}

function applyWizzyLowStockBadges() {
    // Low-stock badge removed. Shopify qty / Coming Soon are owned by hydrateWizzyCardMeta.
    // Keep a light SKU + interim Shopify weight warm-up for cards that render before hydrate.
    var cards = document.querySelectorAll(
        '.wizzy-search-results-list .plp-card, .wizzy-autocomplete-wrapper .plp-card'
    );

    cards.forEach(function (card) {
        if (card.getAttribute('data-wizzy-low-stock-checked')) {
            return;
        }

        var url = getWizzyCardProductUrl(card);
        if (!url) {
            return;
        }

        card.setAttribute('data-wizzy-low-stock-checked', 'true');

        var existingLow = card.querySelector('[data-wizzy-low-stock]');
        if (existingLow) existingLow.remove();

        getAvailableStockForVariants(url).then(function (stockMap) {
            var resolvedSku = stockMap && stockMap._sku ? String(stockMap._sku).trim() : '';
            if (resolvedSku) {
                setWizzyCardSku(card, resolvedSku);
            }
            // Weight stays Checking... until products-batch (no Shopify interim paint).
        });
    });
}
try {
    const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
        if (!targetNode) return;
        const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
        var isOpen =
            autocompleteElement &&
            window.getComputedStyle(autocompleteElement).display === "flex";
        if (isOpen) {
            document.body.classList.add("wizzy-autocomplete-open");
            setTimeout(syncAutocompleteWidth, 0);
            scheduleHydrateWizzyCardMeta(60);
        } else {
            document.body.classList.remove("wizzy-autocomplete-open");
        }
    }
    const config = {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["style"]
    }
      , callback = function(mutationsList, observer2) {
        for (const mutation of mutationsList) {
            updateBodyClass();
            break
        }
    }
      , observer = new MutationObserver(callback);
    targetNode && (observer.observe(targetNode, config),
    updateBodyClass());
} catch (autocompleteObserverError) {
    console.error('[Wizzy] autocomplete observer setup failed', autocompleteObserverError);
}

var WIZZY_SEARCH_VIEW_KEY = 'wizzy-search-plp-view';
var wizzyViewSwitcherTimer;
var WIZZY_SEARCH_VIEWS = { grid: true, inventory: true };

function getWizzySearchWrapper() {
    // Prefer the live results wrapper that currently has products / filters.
    var wrappers = document.querySelectorAll('.wizzy-search-wrapper');
    if (!wrappers.length) return null;
    for (var i = 0; i < wrappers.length; i++) {
        var candidate = wrappers[i];
        if (
            candidate.querySelector('.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .search-filters-top-wrapper')
        ) {
            return candidate;
        }
    }
    return wrappers[0];
}

function getWizzySearchResultsLists() {
    var wrapper = getWizzySearchWrapper();
    if (!wrapper) return [];
    return Array.prototype.slice.call(wrapper.querySelectorAll('.wizzy-search-results-list'));
}

function getWizzyCartRoute(suffix) {
    var root = '/';
    try {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
            root = window.Shopify.routes.root;
        }
    } catch (e) {
        /* noop */
    }
    if (root.slice(-1) !== '/') root += '/';
    return root + suffix;
}

/** Marks the Wizzy results area as a PLP view host so order-sheet + quick-view handlers work. */
function ensureWizzyPlpViewHost() {
    var wrapper = getWizzySearchWrapper();
    if (!wrapper) return null;

    var host =
        wrapper.querySelector('.plp-view-host[data-wizzy-plp-host]') ||
        wrapper.querySelector('.wizzy-search-results') ||
        wrapper;

    host.classList.add('plp-view-host');
    host.setAttribute('data-wizzy-plp-host', '');
    host.setAttribute('data-plp-enable-inventory', 'true');
    host.setAttribute('data-plp-enable-list', 'false');
    host.setAttribute('data-plp-enable-view4', 'false');
    host.setAttribute('data-plp-persist-views', 'true');
    if (!host.dataset.cartAddJs) {
        host.dataset.cartAddJs = getWizzyCartRoute('cart/add.js');
    }
    if (!host.dataset.cartJson) {
        host.dataset.cartJson = getWizzyCartRoute('cart.js');
    }
    return host;
}

function getWizzyViewSwitcherMarkup() {
    return (
        '<div class="plp-view-switcher plp-view-switcher--buttons plp-view-switcher--right" role="toolbar" aria-label="Product display layout">' +
        '<span class="plp-view-switcher__inner" role="presentation">' +
        '<button type="button" class="plp-view-switcher__btn" data-wizzy-view-switch="grid" aria-pressed="true" aria-label="Grid" onclick="window.__aoneSetWizzyView && window.__aoneSetWizzyView(\'grid\'); return false;">' +
        '<span class="plp-view-switcher__text">Grid</span>' +
        '</button>' +
        '<button type="button" class="plp-view-switcher__btn" data-wizzy-view-switch="inventory" aria-pressed="false" aria-label="Order sheet" onclick="window.__aoneSetWizzyView && window.__aoneSetWizzyView(\'inventory\'); return false;">' +
        '<span class="plp-view-switcher__text">Order sheet</span>' +
        '</button>' +
        '</span>' +
        '</div>'
    );
}

/**
 * Document-level click so Grid / Order sheet still works after Wizzy
 * rebuilds the top bar (default in-stock filter requests).
 */
function bindWizzyViewSwitcherClicks() {
    if (document.documentElement.getAttribute('data-wizzy-view-switch-bound') === 'true') {
        return;
    }
    document.documentElement.setAttribute('data-wizzy-view-switch-bound', 'true');

    window.__aoneSetWizzyView = function (view) {
        setWizzySearchView(view, true);
    };

    document.addEventListener('click', function (event) {
        if (!(event.target instanceof Element)) return;
        var btn = event.target.closest('[data-wizzy-view-switch]');
        if (!btn) return;

        var view = btn.getAttribute('data-wizzy-view-switch');
        if (view && WIZZY_SEARCH_VIEWS[view]) {
            event.preventDefault();
            setWizzySearchView(view, true);
        }
    });
}

/**
 * Group Home / sep / current into one trail div so the breadcrumb nav can
 * hold trail + Grid/Order sheet as two siblings.
 * @param {Element} nav
 * @returns {HTMLElement|null}
 */
function wrapWizzyBreadcrumbTrail(nav) {
    if (!(nav instanceof HTMLElement)) return null;

    var directChildren = nav.children;
    for (var c = 0; c < directChildren.length; c++) {
        if (directChildren[c].classList.contains('plp-breadcrumbs__trail')) {
            return directChildren[c];
        }
    }

    var trail = document.createElement('div');
    trail.className = 'plp-breadcrumbs__trail';

    var nodes = Array.prototype.slice.call(nav.childNodes);
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.nodeType === 1) {
            var el = node;
            if (
                el.getAttribute('data-wizzy-view-controls') != null ||
                el.classList.contains('wizzy-search-view-switcher')
            ) {
                continue;
            }
        }
        trail.appendChild(node);
    }

    nav.insertBefore(trail, nav.firstChild);
    return trail;
}

var WIZZY_VIEW_SWITCHER_MOBILE_MQ = '(max-width: 767px)';

function isWizzyMobileViewSwitcherViewport() {
    return window.matchMedia(WIZZY_VIEW_SWITCHER_MOBILE_MQ).matches;
}

function bindWizzyViewSwitcherViewport() {
    if (document.documentElement.getAttribute('data-wizzy-view-switch-mq-bound') === 'true') {
        return;
    }
    document.documentElement.setAttribute('data-wizzy-view-switch-mq-bound', 'true');

    var mq = window.matchMedia(WIZZY_VIEW_SWITCHER_MOBILE_MQ);
    var onChange = function () {
        injectWizzyViewSwitcher();
    };

    if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
        mq.addListener(onChange);
    }
}

function mountWizzyViewSwitcherInTopBar(topBar, controls) {
    if (!topBar || !controls || topBar.contains(controls)) return;
    var sortWrap = topBar.querySelector('.wizzy-search-sort-wrapper');
    if (sortWrap) {
        topBar.insertBefore(controls, sortWrap);
    } else {
        topBar.appendChild(controls);
    }
}

function injectWizzyViewSwitcher() {
    var wrapper = getWizzySearchWrapper();
    if (!wrapper) {
        return;
    }

    ensureWizzyPlpViewHost();
    bindWizzyViewSwitcherClicks();
    bindWizzyViewSwitcherViewport();

    var nav = wrapper.querySelector('nav.plp-breadcrumbs.wizzy-breadcrumb');
    var topBar = wrapper.querySelector('.search-filters-top-wrapper');
    if (!nav && !topBar) {
        return;
    }

    if (nav) {
        wrapWizzyBreadcrumbTrail(nav);
    }

    var controls = wrapper.querySelector('[data-wizzy-view-controls]');
    if (!controls) {
        controls = document.createElement('div');
        controls.className = 'wizzy-search-view-switcher';
        controls.setAttribute('data-wizzy-view-controls', '');
        controls.innerHTML = getWizzyViewSwitcherMarkup();
    } else if (
        controls.querySelector('[data-wizzy-view-switch="list"]') ||
        !controls.querySelector('[data-wizzy-view-switch="inventory"]')
    ) {
        controls.innerHTML = getWizzyViewSwitcherMarkup();
    }

    /* Mobile collection: beside Home / Collection in the breadcrumb nav.
     * Desktop collection + SLP: previous top-bar slot next to Sort.
     * Re-home after Wizzy replaces filter chrome, and on viewport change. */
    var useNav = !!(nav && isWizzyMobileViewSwitcherViewport());
    if (useNav) {
        if (!nav.contains(controls)) {
            nav.appendChild(controls);
        }
        return;
    }

    mountWizzyViewSwitcherInTopBar(topBar, controls);
}
function normalizeWizzySearchView(view) {
    if (view === 'list') return 'inventory';
    if (view === 'inventory') return 'inventory';
    return 'grid';
}

function setWizzySearchView(view, persist) {
    var logical = normalizeWizzySearchView(view);
    var isInventory = logical === 'inventory';

    if (persist) {
        try {
            localStorage.setItem(WIZZY_SEARCH_VIEW_KEY, logical);
        } catch (error) {
            /* noop */
        }
    }

    var wrapper = getWizzySearchWrapper();
    var resultsLists = getWizzySearchResultsLists();
    if (!wrapper) {
        return;
    }

    /* Persist + paint toolbar even if results list is mid re-render (in-stock filter). */
    var controls = wrapper.querySelector('[data-wizzy-view-controls]');
    if (controls) {
        controls.querySelectorAll('[data-wizzy-view-switch]').forEach(function (btn) {
            var active = btn.getAttribute('data-wizzy-view-switch') === logical;
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
    }

    if (!resultsLists.length) {
        return;
    }

    var host = ensureWizzyPlpViewHost();

    resultsLists.forEach(function (resultsList) {
        resultsList.classList.toggle('plp-product-grid--list-layout', false);
        resultsList.classList.toggle('plp-product-grid--inventory-layout', isInventory);
        resultsList.setAttribute('data-plp-layout', logical);
        resultsList.dataset.plpView = logical;
    });

    wrapper.classList.toggle('wizzy-search-wrapper--layout-list', false);
    wrapper.classList.toggle('wizzy-search-wrapper--layout-inventory', isInventory);

    if (host) {
        host.classList.toggle('plp-view-host--layout-list', false);
        host.classList.toggle('plp-view-host--layout-inventory', isInventory);
        host.dataset.plpDefaultView = logical;
    }

    // Re-paint meta after layout switch (grid + order sheet share the same productIds).
    // Do not schedule a products-batch — membership is unchanged.
    restoreWizzyMetaFromCache();
}

function initWizzySearchViewSwitcher() {
    injectWizzyViewSwitcher();
    syncWizzyProductHandlesInDom();

    var view = 'grid';
    try {
        var stored = localStorage.getItem(WIZZY_SEARCH_VIEW_KEY);
        if (stored) {
            view = normalizeWizzySearchView(stored);
        }
    } catch (error) {
        /* noop */
    }

    setWizzySearchView(view, false);
}

/** Fallback: open Quick View from Order sheet rows if PLP host binding is not ready yet. */
function bindWizzyOrderSheetQuickViewFallback() {
    if (document.documentElement.getAttribute('data-wizzy-os-qv-bound') === 'true') {
        return;
    }
    document.documentElement.setAttribute('data-wizzy-os-qv-bound', 'true');

    document.addEventListener(
        'click',
        function (event) {
            if (!(event.target instanceof Element)) return;
            var wrapper = getWizzySearchWrapper();
            if (!wrapper || !wrapper.classList.contains('wizzy-search-wrapper--layout-inventory')) return;
            if (!wrapper.contains(event.target)) return;
            if (event.target.closest('[data-order-sheet-details-panel], [data-plp-details-panel]')) return;

            var item = event.target.closest('[data-order-sheet-item], [data-plp-inventory-item]');
            if (!item || !wrapper.contains(item)) return;

            var row = event.target.closest('[data-order-sheet-row]') || item.querySelector('[data-order-sheet-row]');
            if (!row) return;

            var handle = (
                row.getAttribute('data-product-handle') ||
                item.getAttribute('data-product-handle') ||
                ''
            ).trim();
            if (!handle || handle.indexOf('[[') !== -1) {
                handle = '';
                var gridItem = item.closest('.plp-product-grid__item, .wizzy-result-product');
                var link = (gridItem || item).querySelector('a[href*="/products/"]');
                var href = link instanceof HTMLAnchorElement ? link.getAttribute('href') || '' : '';
                var match = href.match(/\/products\/([^/?#]+)/);
                if (match && match[1]) {
                    handle = decodeURIComponent(match[1]).trim();
                    if (handle) {
                        row.setAttribute('data-product-handle', handle);
                        item.setAttribute('data-product-handle', handle);
                    }
                }
            }
            if (!handle) return;

            /* Charm Order Sheet uses inline accordion via plp-table-details — never open QV here. */
            var charmFlag =
                item.getAttribute('data-is-charm-product') === 'true' ||
                row.getAttribute('data-is-charm-product') === 'true';
            var typeKey = String(
                item.getAttribute('data-product-type') || row.getAttribute('data-product-type') || ''
            )
                .trim()
                .toLowerCase();
            var titleEl = item.querySelector('.inventory-product-row__title');
            var titleText = titleEl ? String(titleEl.textContent || '') : '';
            var path = String(window.location.pathname || '').toLowerCase();
            var isCharm =
                charmFlag ||
                typeKey === 'charm' ||
                typeKey === 'charms' ||
                /(^|[^a-z])charm(s)?([^a-z]|$)/i.test(typeKey) ||
                /(^|[^a-z])charm(s)?([^a-z]|$)/i.test(titleText) ||
                path.indexOf('/charms') !== -1 ||
                path.indexOf('/charm-') !== -1;
            if (isCharm) return;

            var qv = window.__aoneQuickViewModalController;
            if (!qv || typeof qv.open !== 'function') return;

            /* Let plp-table-details handle the click when a real PLP host wraps the item. */
            if (item.closest('.plp-view-host[data-plp-enable-inventory="true"]')) return;

            event.preventDefault();
            event.stopPropagation();
            qv.open(handle);
        },
        true
    );
}

try {
    bindWizzyOrderSheetQuickViewFallback();

    new MutationObserver(function () {
        clearTimeout(wizzyViewSwitcherTimer);
        wizzyViewSwitcherTimer = setTimeout(initWizzySearchViewSwitcher, 150);
    }).observe(document.body, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWizzySearchViewSwitcher, { once: true });
    } else {
        initWizzySearchViewSwitcher();
    }
} catch (viewSwitcherStartupError) {
    console.error('[Wizzy] view switcher startup failed', viewSwitcherStartupError);
}

ensureWizzyMetaPageshowBinding();

// Ensure the card-hydration observer is active at script-load time on ALL pages.
// On Collection pages, onWizzyScriptLoaded fires before rendering, so the observer inside
// it is sufficient. On SLP (/pages/search), the Wizzy SDK's search module may render cards
// before or concurrently with onWizzyScriptLoaded — this global observer guarantees detection.
// The __aoneWizzyCardHydrateObserverBound flag prevents duplicates.
var __wizzyCardHydrateLowStockTimer;
if (!window.__aoneWizzyCardHydrateObserverBound) {
    window.__aoneWizzyCardHydrateObserverBound = true;
    new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            if (!added || !added.length) continue;
            for (var j = 0; j < added.length; j++) {
                if (addedNodeHasWizzyCard(added[j])) {
                    wizzyCardHydratePending = true;
                    break;
                }
            }
            if (wizzyCardHydratePending) break;
        }
        clearTimeout(__wizzyCardHydrateLowStockTimer);
        __wizzyCardHydrateLowStockTimer = setTimeout(function () {
            applyWizzyLowStockBadges();
            if (!wizzyCardHydratePending) return;
            wizzyCardHydratePending = false;
            // Same shared reconcile as onWizzyScriptLoaded observer above.
            // Handles Wizzy replacing <li class="wizzy-result-product"> after
            // BFCache Back when VIEW_RENDERED does not fire.
            scheduleHydrateWizzyCardMeta(150);
        }, 200);
    }).observe(document.body, { childList: true, subtree: true });
}

scheduleHydrateWizzyCardMeta(300);


